<template>
    <v-container fluid>
        <!--    Diálogo Modal Permitir Giro Horizontal/Vertical Posicion Placas   -->
        <v-dialog v-model="dialogHorizontal" max-width="450">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            Configuración Pantalla
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogHorizontal = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                  <v-card-text class="text-center">
                        <v-layout align-center justify-center fill-height>
                          Orientación de la pantalla:
                          <v-spacer></v-spacer>
                          <v-radio-group v-model="horizontal" row mandatory @change="changeHorizontalVertical">
                            <v-radio label="Horizontal" :value="true"></v-radio>
                            <v-spacer></v-spacer>
                            <v-radio label="Vertical" :value="false"></v-radio>
                          </v-radio-group>
                        </v-layout>
                        <v-spacer></v-spacer>
                        <v-divider></v-divider>
                        <v-spacer></v-spacer>
                        <v-layout align-center justify-center fill-height>
                          Ubicación ventana placas:
                          <v-spacer></v-spacer>
                          <v-radio-group v-if="horizontal" v-model="placas_abajo" row mandatory @change="changePlatesWindow">
                            <v-radio label="Izquierda" :value="false"></v-radio>
                            <v-spacer></v-spacer>
                            <v-radio label="Derecha" :value="true"></v-radio>
                          </v-radio-group>
                          <v-radio-group v-else v-model="placas_abajo" row mandatory @change="changePlatesWindow">
                            <v-radio label="Arriba" :value="false"></v-radio>
                            <v-spacer></v-spacer>
                            <v-radio label="Abajo" :value="true"></v-radio>
                          </v-radio-group>
                        </v-layout>
                    </v-card-text>
                </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para agregar acompanantes -->
        <v-dialog v-model="dialogAdditionalPersonCode" persistent width="500">
          <v-card class="mx-auto elevation-7">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{$t('additional_person')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogAdditionalPersonCode = false"
              ><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="black"
                      dark
                      fab
                      icon
                      x-large
                      class="mr-2"
                      :loading="loadingTakePicture"
                      @click="takePicture1AdditionalPerson"
                  >
                    <v-icon>
                      mdi-camera
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{$t('capture_photo')}}</span>
              </v-tooltip>
              <v-btn
                  v-show="photosCameraAdditionalPerson.length !== 0"
                  icon
                  large
                  color="blue"
                  :loading="loading"
                  @click="indexTag = 0, imageCapturedAdditional = 'data:image/jpeg;base64,' + photosCameraAdditionalPerson[0].data, rotateBase64Image90degAdditionalPerson(imageCapturedAdditional, true, 0)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          medium
                          v-bind="attrs"
                          v-on="on"
                      >
                        mdi-rotate-right
                      </v-icon>
                    </template>
                    <span>Girar 90°</span>
                  </v-tooltip>
              </v-btn>
              <v-btn
                  v-show="photosCameraAdditionalPerson.length !== 0"
                  icon
                  large
                  color="primary"
                  :loading="loading"
                  @click="indexTag = 0, imageCapturedAdditional = 'data:image/jpeg;base64,' + photosCameraAdditionalPerson[0].data, rotateBase64Image180degAdditionalPerson(imageCapturedAdditional, true, 0)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          medium
                          v-bind="attrs"
                          v-on="on"
                      >
                        mdi-rotate-right
                      </v-icon>
                    </template>
                    <span>Girar 180°</span>
                  </v-tooltip>
              </v-btn>
              <v-text-field
                  v-model="editedItem.full_name"
                  autofocus
                  prepend-icon="mdi-account"
                  name="first_name"
                  :label="$t('full_name')"
                  outlined
              >
              </v-text-field>
                <v-row>
                  <v-img
                      v-if="photosCameraAdditionalPerson.length !== 0"
                      :src="'data:image/jpeg;base64,' + photosCameraAdditionalPerson[0].data"
                      position="center center"
                      class="grey lighten-2 mb-4"
                  ></v-img>
                  <v-img
                      v-else
                      :src="require('../../assets/noimage.png')"
                      position="center center"
                      class="grey lighten-2 mb-4"
                  ></v-img>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn
                    large
                    color="error"
                    @click="dialogAdditionalPersonCode = false"
                >{{$t('cerrar')}}
                </v-btn>
                <v-spacer/>
                <v-btn
                    :disabled="photosCameraAdditionalPerson.length === 0 || editedItem.full_name.length === 0"
                    large
                    color="success"
                    @click="addResident()"
                >{{$t('agregar')}}
                </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Correccion de Datos    -->
        <v-dialog v-model="dialog_correction_request" persistent width="500">
            <v-card class="justify-center">
                <v-card-title class="primary display-1 text--primary justify-center">
                    {{$t('data_correction')}}
                </v-card-title>
                <v-card-text align="center">
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                          v-model="first_name_correction"
                          prepend-icon="mdi-account"
                          name="first_name"
                          :label="$t('Nombre')"
                          :error-messages="errores.first_name"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                          v-model="last_name_correction"
                          prepend-icon="mdi-account-outline"
                          name="last_name"
                          :label="$t('Apellido')"
                          :error-messages="errores.last_name"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-checkbox
                          v-model="msg_photograph_blurred"
                          :label="$t('msg_photograph_blurred')">
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialog_correction_request = false"
                    >
                        {{$t('cancelar')}}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                            color="primary"
                            :loading="loading_correction_request"
                            @click="send_correction_request()"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores en Accesos    -->
        <v-dialog v-model="dialog_errores" persistent width="500">
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text align="center">
                    <h3 class="text-xs-center">{{errores_guard}}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = ''"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
            <v-card v-if="entradaResidente" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_residente')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, qr_code = '', entrada = false, salida = false, entradaResidente = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.resident).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.resident.idUser.idFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('residente')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.resident.idUser.first_name}}
                                                        {{ info_invitation.resident.idUser.last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.resident.street}} {{info_invitation.resident.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{  info_invitation.resident.idUser.cellNumber}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="success"
                            @click="dialog = false, qr_code = '', entrada = false, salida = false, entradaResidente = false, activar_camara = true, deleteRecord()"
                    >{{$t('acceso')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-if="entrada" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.invitation).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestFName}}
                                                        {{ info_invitation.invitation.guestLName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_anfitrion')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.hostIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostFirstName}}
                                                        {{ info_invitation.invitation.hostLastName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="error"
                            @click="dialog = false, activar_camara = true"
                    >{{this.$t('cerrar')}}
                    </v-btn>
                    <v-btn
                            large
                            color="success"
                            @click="create_acceso(), dialog = false, qr_code='', entrada = false, salida = false, activar_camara = true"
                    >{{$t('acceso')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-if="salida" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.invitation).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestFName}}
                                                        {{ info_invitation.invitation.guestLName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                                <br>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_anfitrion')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.hostIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas" style="width:100%">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostFirstName}}
                                                        {{ info_invitation.invitation.hostLastName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>{{$t('celular')}}:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>{{$t('numero_casa')}}:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('Información de Acceso')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <table :color="data_access[0].pase_salida ? 'success' : 'error'"  id="datas" style="width:100%">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Fecha y hora de acceso')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_access[0].dateTime_EntranceAccess}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Fecha y hora de salida')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_access[0].dateTime_ExitAccess ? data_access[0].dateTime_ExitAccess : "Pendiente" }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Estado')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{data_access[0].status == '1' ? "Adentro" : "Afuera"}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                        <v-btn
                                large
                                color="error"
                                @click="dialog = false, activar_camara = true"
                        >{{ $t('cerrar')}}
                        </v-btn>
                        <v-btn
                                large
                                color="success"
                                @click="update_acceso(data_access[0].id), activar_camara = true"
                        >{{$t('registrar_salida')}}
                        </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogData" persistent
                scrollable
                width="700">
            <v-card class="mx-auto elevation-7">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('access_without_code')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="clear(), dialogData = false"
                    ><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text align="center">
                    <v-row>
                        <v-col>
                            <img  width="400" height="250" :src="imageCaptured">
                            <v-autocomplete
                                    autofocus
                                    v-model="idHouse"
                                    prepend-icon="mdi-home-city"
                                    name="idHouse"
                                    :item-text="example"
                                    item-value="id"
                                    :label="$t('casas')"
                                    :placeholder="$t('search_by_house_number')"
                                    :filter="customFilter"
                                    :error-messages="errors.house"
                                    :items="houses"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    outlined
                                    autocomplete="off"
                            >
                                <template v-slot:item="data">
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                                </template>
                            </v-autocomplete>
                            <v-text-field
                                    v-model="first_name"
                                    autofocus
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('full_name')"
                                    outlined
                                    :error-messages="errors.name_guest"
                            >
                            </v-text-field>
                            <v-textarea
                                    v-model="notes"
                                    autocomplete="on"
                                    prepend-icon="mdi-text"
                                    name="notes"
                                    :placeholder="$t('placeholder_notas')"
                                    :label="$t('Notas')"
                                    outlined
                                    :error-messages="errors.comments"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="primary"
                            :loading="loading"
                            @click="createAccessNoCode()"
                    >{{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
          <v-col
              v-show="placas_abajo"
              cols="12"
              :sm="horizontal === true? 8 : 12"
          >
            <v-tabs v-model="tabActivo" fixed-tabs background-color="primary">
              <v-tab>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="black"
                        dark
                        fab
                        icon
                        x-large
                        class="mr-2"
                        @click="getHorizontalVertical(), getPlatesWindow, dialogHorizontal = true"
                    >
                      <v-icon>mdi-cog-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('configuracion')}}</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <div v-show="photosCamera.length > 0">
                  <v-badge color="black">
                    <template v-slot:badge>
                      <span>{{photosCamera.length}}</span>
                    </template>
                    <span>{{$t('acceso_sin_codigo')}}</span>
                  </v-badge>
                </div>
                <div v-show="photosCamera.length === 0">
                  {{$t('acceso_sin_codigo')}}
                </div>
              </v-tab>
              <v-tab>
                <div v-show="qrCodes.length > 0">
                  <v-badge color="black">
                    <template v-slot:badge>
                      <span>{{qrCodes.length}}</span>
                    </template>
                    <span>{{$t('entradas_salidas')}}</span>
                  </v-badge>
                </div>
                <div v-show="qrCodes.length === 0">
                  {{$t('entradas_salidas')}}
                </div>
              </v-tab>
              <v-tab-item>
                <v-card class="mx-auto">
                  <v-card-text class="py-4 font-weight-bold">
                    <v-card>
                      <v-toolbar dark color="primary">
                        <v-icon v-if="getProfile.enable_parcel === false">mdi-truck</v-icon>
                        <v-checkbox hide-details class="shrink mr-2" v-if="getProfile.enable_parcel === false" v-model="bandParcel" color="black"></v-checkbox>
                        {{getProfile.enable_parcel === false ? $t('parcel_capital_letters') : ''}}
                        <v-btn text router to="/events"><v-icon >mdi-calendar-star</v-icon>{{$t('events')}}</v-btn>
                        <v-btn text router to="/delivery"><v-icon>mdi-moped</v-icon>Delivery</v-btn>
                        <v-spacer/>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="black"
                                dark
                                fab
                                icon
                                x-large
                                class="mr-2"
                                :loading="loadingTakePicture"
                                @click="takePicture1"
                            >
                              <v-icon>
                                mdi-camera
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{$t('capture_photo')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-show="getProfile.idHousingUnit === '3999d21c-555d-4be9-9179-c2cc34e2c825' || getProfile.idHousingUnit === '898109fd-bb69-4d2f-a223-5457810e2171'"
                                v-bind="attrs"
                                v-on="on"
                                color="black"
                                dark
                                fab
                                icon
                                x-large
                                class="mr-2"
                                :loading="loadingTakePicture"
                                @click="takePicture1INEBack"
                            >
                              <v-icon>
                                mdi-camera-retake
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{$t('capture_photo')}} Back</span>
                        </v-tooltip>
                      </v-toolbar>
                      <v-card-text>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="10"
                          >
                            <v-alert
                                v-show="bandMsgVacationMode"
                                type="error"
                                outlined
                            >
                              <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                            </v-alert>
                            <v-alert
                                v-show="bandInstructions"
                                type="info"
                                outlined
                            >
                              <strong>{{ msgInstructions }}</strong>
                            </v-alert>
                            <br>
                            <v-autocomplete
                                v-show="bandParcel"
                                v-model="idHouse2"
                                :search-input.sync="searchInput"
                                @change="searchInput=''"
                                prepend-icon="mdi-home-city"
                                name="idHouse2"
                                :item-text="example"
                                item-value="id"
                                :label="$t('casas')"
                                :placeholder="$t('search_by_street_house_number')"
                                :filter="customFilterNumber"
                                :error-messages="errors.house"
                                :items="houses"
                                no-data-text="Ningún Resultado"
                                outlined
                                multiple
                                chips
                                clearable
                                autocomplete="off"
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click="data.select"
                                    @click:close="remove(data.item)"
                                >
                                  {{ data.item.street }} {{data.item.number}}
                                </v-chip>
                              </template>
                              <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                  <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ data.item.street }} {{data.item.number}}</v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                                v-show="getProfile.booth_registration === false  && !bandParcel"
                                v-model="idHouse"
                                prepend-icon="mdi-home-city"
                                name="idHouse"
                                :item-text="getProfile.show_house_phones === false ? example : example2"
                                item-value="id"
                                :label="$t('casas')"
                                :placeholder="$t('search_by_house_number')"
                                :filter="customFilterNumber"
                                :error-messages="errors.house"
                                :items="houses"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                return-object
                                autocomplete="off"
                                @change="showMessageVacationMode"
                            >
                              <template v-slot:item="data" v-if="getProfile.show_house_phones === false">
                                <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                                <v-spacer/>
                                <v-btn-toggle>
                                  <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                  <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                  <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </template>
                              <template v-slot:item="data" v-else>
                                <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                                v-show="getProfile.booth_registration === true && !bandParcel"
                                v-model="idHouse"
                                prepend-icon="mdi-home-city"
                                name="idHouse"
                                :item-text="getProfile.show_house_phones === false ? example : example3"
                                item-value="id"
                                :label="$t('casas')"
                                :placeholder="$t('search_by_house_number_resident')"
                                :filter="customFilterNumberResident"
                                :error-messages="errors.house"
                                :items="houses"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                return-object
                                autocomplete="off"
                                @change="showMessageVacationMode"
                            >
                              <template v-slot:item="data">
                                <template v-if="getProfile.show_house_phones === false">
                                  <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                                  <v-spacer/>
                                  <v-btn-toggle>
                                    <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                      <v-icon>mdi-phone</v-icon>
                                    </v-btn>
                                    <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                      <v-icon>mdi-phone</v-icon>
                                    </v-btn>
                                    <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                      <v-icon>mdi-phone</v-icon>
                                    </v-btn>
                                  </v-btn-toggle>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                      {{data.item.fullname === '' ? 'n/a' : data.item.fullname}}
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="1"
                              class="text-right"
                          >
                            <v-btn
                                v-show="photosCamera.length !== 0"
                                icon
                                large
                                color="blue"
                                :loading="loading"
                                @click="indexTag = 0, imageCaptured = 'data:image/jpeg;base64,' + photosCamera[0].data, rotateBase64Image90deg(imageCaptured, true, 0, false)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        medium
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                      mdi-rotate-right
                                    </v-icon>
                                  </template>
                                  <span>Girar 90°</span>
                                </v-tooltip>
                            </v-btn>
                            <v-btn
                                v-show="photosCamera.length !== 0"
                                icon
                                large
                                color="primary"
                                :loading="loading"
                                @click="indexTag = 0, imageCaptured = 'data:image/jpeg;base64,' + photosCamera[0].data, rotateBase64Image180deg(imageCaptured, true, 0, false)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        medium
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                      mdi-rotate-right
                                    </v-icon>
                                  </template>
                                  <span>Girar 180°</span>
                                </v-tooltip>
                            </v-btn>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="1"
                              class="text-right"
                          >
                            <v-btn
                                v-show="photosCameraINEBack.length !== 0"
                                icon
                                large
                                color="blue"
                                :loading="loading"
                                @click="indexTag = 0, imageCapturedINEBack = 'data:image/jpeg;base64,' + photosCameraINEBack[0].data, rotateBase64Image90deg(imageCapturedINEBack, true, 0, true)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        medium
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                      mdi-rotate-right
                                    </v-icon>
                                  </template>
                                  <span>Girar 90°</span>
                                </v-tooltip>
                            </v-btn>
                            <v-btn
                                v-show="photosCameraINEBack.length !== 0"
                                icon
                                large
                                color="primary"
                                :loading="loading"
                                @click="indexTag = 0, imageCapturedINEBack = 'data:image/jpeg;base64,' + photosCameraINEBack[0].data, rotateBase64Image180deg(imageCapturedINEBack, true, 0, true)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        medium
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                      mdi-rotate-right
                                    </v-icon>
                                  </template>
                                  <span>Girar 180°</span>
                                </v-tooltip>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="5"
                          >
                            <div class="text--accent-1" v-show="getProfile.show_directory_guards === true && !bandParcel">
                              <div class="ml-6" v-show="idHouse.phone !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name1 === null) || (idHouse.name1 === '')) ? 'n/a' : idHouse.name1}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone2 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name2 === null) || (idHouse.name2 === '')) ? 'n/a' : idHouse.name2}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone2}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone3 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name3 === null) || (idHouse.name3 === '')) ? 'n/a' : idHouse.name3}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone3}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone4 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name4 === null) || (idHouse.name4 === '')) ? 'n/a' : idHouse.name4}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone4}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone5 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name5 === null) || (idHouse.name5 === '')) ? 'n/a' : idHouse.name5}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone5}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone6 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name6 === null) || (idHouse.name6 === '')) ? 'n/a' : idHouse.name6}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone6}}</strong></h2><br></div><br>
                            </div>
                            <v-autocomplete
                                v-show="!bandParcel"
                                v-model="idService"
                                prepend-icon="mdi-tag-multiple"
                                name="idService"
                                :item-text="textServices"
                                item-value="name"
                                :label="$t('service_catalog')"
                                :placeholder="$t('search_by_name')"
                                :filter="customFilterService"
                                :items="services"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                autocomplete="off"
                            >
                              <template v-slot:item="data">
                                <strong>{{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                              </template>
                            </v-autocomplete>
                            <v-text-field
                                v-model="first_name"
                                prepend-icon="mdi-account"
                                name="first_name"
                                :label="$t('full_name')"
                                outlined
                                :error-messages="errors.name_guest"
                            >
                            </v-text-field>
                            <v-combobox
                                v-show="getProfile.idHousingUnit === '3999d21c-555d-4be9-9179-c2cc34e2c825' || getProfile.idHousingUnit === '9dbdc4ea-6909-4f99-95da-578b2f6de5f1' || getProfile.idHousingUnit === '8c19e21b-3e74-4405-aeb3-297f9f573ab1'"
                                v-model="resident_name"
                                name="resident_name"
                                outlined
                                clearable
                                prepend-icon="mdi-account-check"
                                item-text="fullname"
                                item-value="fullname"
                                @change="onChangeComboBoxResidents"
                                :label="$t('who_authorized')"
                                :items="residents"
                                autocomplete="off"
                                :error-messages="errors.resident_name"
                            ></v-combobox>
                            <v-textarea
                                v-model="notes"
                                autocomplete="on"
                                prepend-icon="mdi-text"
                                name="notes"
                                :placeholder="$t('placeholder_notas')"
                                :label="$t('Notas')"
                                outlined
                                :error-messages="errors.comments"
                            ></v-textarea>
                            <div align="center">
                              <v-btn
                                  v-show="photosCamera.length !== 0 || photosCameraINEBack.length !== 0"
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  :loading="loading"
                                  :disabled="loading"
                                  @click="indexTag = 0, otro()">
                                {{$t('acceso')}}
                              </v-btn>
                              <v-checkbox
                                v-if="bandParcel === false"
                                v-model="bandAdditionalPersonCode"
                                name="bandAdditionalPersonCode"
                                :label="$t('msg_additional_person')"
                              >
                              </v-checkbox>
                              <v-btn
                                color="primary"
                                v-if="bandAdditionalPersonCode === true && bandParcel === false"
                                @click="cleanAdditionalPersonFields(), dialogAdditionalPersonCode = true"
                              >{{$t('additional_person')}}</v-btn>
                            </div>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="7"
                          >
                            <v-row>
                              <v-img
                                  v-if="photosCamera.length !== 0"
                                  :src="'data:image/jpeg;base64,' + photosCamera[0].data"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                              <v-img
                                  v-else
                                  :src="require('../../assets/noimage.png')"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                            </v-row>
                            <v-row v-show="getProfile.idHousingUnit === '3999d21c-555d-4be9-9179-c2cc34e2c825' || getProfile.idHousingUnit === '898109fd-bb69-4d2f-a223-5457810e2171'">
                              <v-img
                                  v-if="photosCameraINEBack.length !== 0"
                                  :src="'data:image/jpeg;base64,' + photosCameraINEBack[0].data"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                              <v-img
                                  v-else
                                  :src="require('../../assets/noimage.png')"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12">
                            <div v-if="bandAdditionalPersonCode === true && bandParcel === false">
                              <v-data-table
                                  :headers="headers"
                                  :items="additionalPersons"
                                  :footer-props="{
                                        itemsPerPageOptions: [
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}
                                        ],
                                        itemsPerPageText: $t('filas_por_pagina')
                                    }"
                                  :no-data-text="$t('no_records_yet')"
                                  class="elevation-1"
                              >
                                <template v-slot:item.full_name="{ item }">
                                  {{ item.full_name}}
<!--                                  <div v-if="errores_ter[residentes.indexOf(item)]"  class="red&#45;&#45;text">{{errores_ter[residentes.indexOf(item)].first_name}}</div>-->
                                </template>
<!--                                <template v-slot:item.photo="{ item }">-->
<!--                                  {{ item.photo}}-->
<!--&lt;!&ndash;                                  <div v-if="errores_ter[residentes.indexOf(item)]" class="red&#45;&#45;text">{{errores_ter[residentes.indexOf(item)].last_name}}</div>&ndash;&gt;-->
<!--                                </template>-->
                                <template v-slot:item.action="{ item }">
                                  <v-icon
                                      medium
                                      color="grey"
                                      class="mr-2"
                                      @click="editResident(item)"
                                  >
                                    mdi-pencil
                                  </v-icon>
                                  <v-icon
                                      medium
                                      color="red"
                                      @click="deleteResident(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                              </v-data-table>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
<!--                    <v-card v-show="photosCamera.length === 0">-->
<!--                      <v-card-text class="text-center">-->
<!--                        <v-btn-->
<!--                            color="black"-->
<!--                            dark-->
<!--                            fab-->
<!--                            x-large-->
<!--                            :loading="loadingTakePicture"-->
<!--                            @click="takePicture1"-->
<!--                        >-->
<!--                          <v-icon>mdi-camera</v-icon>-->
<!--                        </v-btn>-->
<!--                        <v-spacer/>-->
<!--                        <h2>{{$t('no_registros_pase_salida')}}</h2>-->
<!--                      </v-card-text>-->
<!--                    </v-card>-->
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card class="mx-auto">
                  <v-card-text class="py-0">
                    <v-timeline dense v-if="qrCodes.length !== 0">
                      <v-slide-x-transition
                          group
                          hide-on-leave
                      >
                        <v-timeline-item
                            v-for="(item, index) in qrCodes"
                            :key="item.data"
                            small
                            fill-dot
                        >
                          <!-- MENSAJE msg_vacation_mode_activate -->
                          <v-card v-if="item.status === -5">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_vacation_mode_activate')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE msg_canceled_invitation -->
                          <v-card v-if="item.status === -3">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_canceled_invitation')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- REGISTRAR ENTRADA/SALIDA TRABAJADORES -->
                          <v-card v-else-if="item.status === -1">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <h4>{{$t('info_residente')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-alert
                                      v-show="item.info.resident.vacation_mode && !item.info.resident.allow_access_residents"
                                      type="error"
                                  >
                                    <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                  </v-alert>
                                  <v-alert
                                      v-show="item.info.resident.instructions !== '' && item.info.resident.instructions !== null"
                                      type="info"
                                  >
                                    <strong>{{ item.info.resident.instructions }}</strong>
                                  </v-alert>
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.resident.idUser.idFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('residente')}}:
                                          </th>
                                          <td>
                                            {{ item.info.resident.idUser.first_name}}
                                            {{ item.info.resident.idUser.last_name}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.resident.street}} {{item.info.resident.numberHouse}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{  item.info.resident.idUser.cellNumber}}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer/>
                              <v-btn
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="deleteItem(index)">
                                {{$t('acceso')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <v-card v-else-if="item.status === 0">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('mensaje_qr_no_valido')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 1">
                            <v-toolbar dark color="orange">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="orange"
                                  border="left"
                                  type="warning"
                                  outlined
                              >
                                {{$t('mensaje_acceso_completo')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 2">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <br>
                              <v-alert
                                  v-show="item.info.invitation.supplier"
                                  type="info"
                                  outlined
                              >
                                <strong>{{$t('supplier_mode')}}</strong>{{$t('msg_supplier')}}
                              </v-alert>
                              <v-alert
                                  v-show="item.info.invitation.vacation_mode && !item.info.invitation.allow_access_visitors"
                                  type="error"
                              >
                                <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                              </v-alert>
                              <v-alert
                                  v-show="item.info.invitation.instructions !== '' && item.info.invitation.instructions !== null"
                                  type="info"
                              >
                                <strong>{{ item.info.invitation.instructions }}</strong>
                              </v-alert>
                              <br>
                              <v-layout row wrap>
                                <h4>{{$t('info_invitado')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.invitation.guestIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('Visitante')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestFName}}
                                            {{ item.info.invitation.guestLName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('Asunto')}}
                                          </th>
                                          <td>
                                            {{ item.info.invitation.subject}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('dias_validos')}}:
                                          </th>
                                          <td>
                                            {{item.info.invitation.diary.includes('0') === true ? $t('Lunes') : ''}}
                                            {{item.info.invitation.diary.includes('1') === true ? $t('Martes') : ''}}
                                            {{item.info.invitation.diary.includes('2') === true ? $t('Miercoles') : ''}}
                                            {{item.info.invitation.diary.includes('3') === true ? $t('Jueves') : ''}}
                                            {{item.info.invitation.diary.includes('4') === true ? $t('Viernes') : ''}}
                                            {{item.info.invitation.diary.includes('5') === true ? $t('Sabado') : ''}}
                                            {{item.info.invitation.diary.includes('6') === true ? $t('Domingo') : ''}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('fecha_expiracion')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.expiration }}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-layout v-show="item.info.invitation.correction_request === false" align-center justify-center row wrap>
                                  <v-btn
                                      large
                                      color="error"
                                      @click="index_correction_request = index, id_user_settings = item.info.invitation.id_user_settings, errores = [], first_name_correction = item.info.invitation.guestFName, last_name_correction = item.info.invitation.guestLName, msg_photograph_blurred = true, dialog_correction_request = true"
                                  >{{$t('send_correction_request')}}
                                  </v-btn>
                              </v-layout>
                              <v-layout v-show="item.info.invitation.correction_request === true" align-center justify-center row wrap>
                                  <v-btn
                                      disabled
                                      large
                                      color="error"
                                  >{{$t('data_correction_sent')}}
                                  </v-btn>
                              </v-layout>
                              <v-layout v-show="getProfile.enable_host_info" row wrap>
                                <h4>{{$t('info_anfitrion')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          v-if="getProfile.enable_ine_photo"
                                          :src="item.info.invitation.hostIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                      <v-img
                                          v-else
                                          :src="item.info.invitation.avatarHost"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('residente')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostFirstName}}
                                            {{ item.info.invitation.hostLastName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="text-center">
                              <v-text-field
                                  class="mt-8"
                                  v-model="comments"
                                  name="comments"
                                  outlined
                                  autocomplete="off"
                                  maxlength="300"
                                  prepend-icon="mdi-text"
                                  :label="$t('Notas')"
                              ></v-text-field>
                              ---
                              <v-btn
                                  x-large
                                  color="primary"
                                  @click="otro2(index, item.data)">
                                {{$t('acceso')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <!-- REGISTRAR SALIDA DE INVITACION -->
                          <v-card v-else-if="item.status === 3">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <h4>{{$t('info_invitado')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.invitation.guestIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('Visitante')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestFName}}
                                            {{ item.info.invitation.guestLName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('Asunto')}}
                                          </th>
                                          <td>
                                            {{ item.info.invitation.subject}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('dias_validos')}}:
                                          </th>
                                          <td>
                                            {{item.info.invitation.diary.includes('0') === true ? $t('Lunes') : ''}}
                                            {{item.info.invitation.diary.includes('1') === true ? $t('Martes') : ''}}
                                            {{item.info.invitation.diary.includes('2') === true ? $t('Miercoles') : ''}}
                                            {{item.info.invitation.diary.includes('3') === true ? $t('Jueves') : ''}}
                                            {{item.info.invitation.diary.includes('4') === true ? $t('Viernes') : ''}}
                                            {{item.info.invitation.diary.includes('5') === true ? $t('Sabado') : ''}}
                                            {{item.info.invitation.diary.includes('6') === true ? $t('Domingo') : ''}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('fecha_expiracion')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.expiration }}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-layout v-show="getProfile.enable_host_info" row wrap>
                                <h4>{{$t('info_anfitrion')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          v-if="getProfile.enable_ine_photo"
                                          :src="item.info.invitation.hostIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                      <v-img
                                          v-else
                                          :src="item.info.invitation.avatarHost"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('residente')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostFirstName}}
                                            {{ item.info.invitation.hostLastName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="text-xs-center">
                              <v-spacer/>
                              <v-btn
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="update_acceso(index, item.access)">
                                {{$t('registrar_salida')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <!-- MENSAJE msg_out_date -->
                          <v-card v-else-if="item.status === 4">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE msg_out_date2 -->
                          <v-card v-else-if="item.status === 5">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date2')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE msg_out_date3 -->
                          <v-card v-else-if="item.status === 6">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date3')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- REGISTRAR ENTRADA/SALIDA TRABAJADORES -->
                          <v-card v-else-if="item.status === 10 || item.status === 11">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <h4>{{$t('info_worker')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-alert
                                      v-show="item.info.worker.vacation_mode && !item.info.worker.allow_access_workers"
                                      type="error"
                                  >
                                    <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                  </v-alert>
                                  <v-alert
                                      v-show="item.info.worker.instructions !== '' && item.info.worker.instructions !== null"
                                      type="info"
                                  >
                                    <strong>{{ item.info.worker.instructions }}</strong>
                                  </v-alert>
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.worker.avatar"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('worker')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.first_name}}
                                              {{ item.info.worker.last_name}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('numero_casa')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.street}} {{item.info.worker.numberHouse}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('check_in_time')}}
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.check_in_time}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('check_out_time')}}
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.check_out_time}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('fecha_inicial')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.initial_date }}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('fecha_expiracion')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.final_date }}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('dias_validos')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3 v-if="item.info.worker.diary.includes('0') === true">
                                              {{ $t('Lunes') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('1') === true">
                                              {{ $t('Martes') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('2') === true">
                                              {{ $t('Miercoles') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('3') === true">
                                              {{ $t('Jueves') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('4') === true">
                                              {{ $t('Viernes') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('5') === true">
                                              {{ $t('Sabado') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('6') === true">
                                              {{ $t('Domingo') }}
                                            </h3>
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="text-center" v-if="item.status === 10">
                              <v-text-field
                                  class="mt-8"
                                  v-model="comments"
                                  name="comments"
                                  outlined
                                  autocomplete="off"
                                  maxlength="300"
                                  prepend-icon="mdi-text"
                                  :label="$t('Notas')"
                              ></v-text-field>
                              ---
                              <v-btn
                                  v-if="item.status === 10"
                                  x-large
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="item.status === 11"
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('registrar_salida')}}
                              </v-btn>
                            </v-card-actions>
                            <v-card-actions class="text-center" v-else>
                              <v-spacer/>
                              <v-btn
                                  v-if="item.status === 10"
                                  x-large
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="item.status === 11"
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('registrar_salida')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <!-- MENSAJE msg_out_date_worker0 -->
                          <v-card v-else-if="item.status === 12">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date_worker0')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE msg_out_date_worker1 -->
                          <v-card v-else-if="item.status === 13">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date_worker1')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- LISTA DE INVITADOS A EVENTO-->
                          <v-card v-else-if="item.status === 20">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{$t('event_data')}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <div class="heading text-justify black--text">
                                    <p>
                                      <br><strong>{{$t('event_name')}}: <BIG><U>{{item.info.event.name}}</U></BIG></strong><br>
                                      <strong>{{$t('direccion')}}: <BIG>{{item.info.event.address}}</BIG></strong><br>
                                      <strong>{{$t('Fecha')}}: <BIG>{{item.info.event.date}}</BIG></strong>&nbsp;&nbsp;&nbsp;
                                      <strong>{{$t('event_time')}}: <BIG>{{item.info.event.time}}</BIG></strong><br>
                                    </p>
                                  </div>
                                </v-flex>
                                <v-flex xs12>
                                  <table style="width:100%">
                                  <tr>
                                    <th>{{ $t('invitados') }}</th>
                                    <th>{{ $t('estado') }}</th>
                                  </tr>
                                  <tr v-for="item3 in item.info.guests" :key="item3.id">
                                    <td><strong><BIG>{{ item3.fullName }}</BIG></strong></td>
                                    <td v-if="item3.status === 0">
                                      <v-btn
                                          @click="checkInGuestByEvent(item.info.event, item3), deleteItem(index)"
                                          color="primary">
                                          {{$t('complete_register')}}
                                      </v-btn>
                                    </td>
                                    <td v-else>
                                      <v-icon color="primary">mdi-check</v-icon>{{$t('adentro')}}
                                    </td>
                                  </tr>
                                </table>
                                  <!-- <v-data-table
                                      :headers="headersEvent"
                                      :hide-default-footer="true"
                                      :items="item.info.guests"
                                      :footer-props="{
                                                        itemsPerPageOptions: [
                                                            {text: '5', value: 5},
                                                            {text: '10', value: 10},
                                                            {text: '25', value: 25},
                                                            {text: this.$t('todos'), value: -1}
                                                        ],
                                                        itemsPerPageText: $t('filas_por_pagina')
                                                    }"
                                      :no-data-text="$t('no_records_yet')"
                                      class="elevation-1"
                                  >
                                  </v-data-table> -->
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE EVENTO CANCELADO -->
                          <v-card v-else-if="item.status === 21">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_event_canceled')}}</v-alert>
                            </v-card-text>
                          </v-card>
                        </v-timeline-item>
                      </v-slide-x-transition>
                    </v-timeline>
                    <v-timeline v-else>
                      <v-timeline-item >
                        {{$t('no_registros_pase_salida')}}
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
          <v-col
              v-show="placas_abajo"
              cols="12"
              :sm="horizontal === true? 4 : 8"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-toolbar-title>
                  Placas
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <!-- Camera Mode Selector -->
                <v-row aling="center" class="mb-3">
                  <v-col cols="12">
                    <v-radio-group v-model="cameraMode" row @change="switchCameraMode">
                      <v-radio label="Cámara Local" value="local"></v-radio>
                      <v-radio label="Cámara intrare" value="server"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <!-- Local Camera (Legacy) -->
                <v-row aling="center" v-if="cameraMode === 'local'">
                  <h3>{{$t('select_video_device')}}</h3>
                </v-row>
                <v-row v-if="cameraMode === 'local'">
                  <v-select
                      outlined
                      small
                      v-model="camera"
                      :items="devices"
                      label="Placas"
                      item-text="label"
                      item-value="deviceId"
                  ></v-select>
                </v-row>

                <!-- Server Camera -->
                <v-row aling="center" v-if="cameraMode === 'server'">
                  <h3>Seleccionar Cámara del Servidor</h3>
                </v-row>
                <v-row v-if="cameraMode === 'server'">
                  <v-select
                      outlined
                      small
                      v-model="selectedServerCamera"
                      :items="serverCameras"
                      label="Cámara"
                      item-text="name"
                      return-object
                      @change="onServerCameraChange"
                  ></v-select>
                </v-row>

                {{$t('msg_captura_foto')}}
                <v-img
                    width="100%"
                    aspect-ratio="1"
                    :src="imageCaptured2 !== '' ? imageCaptured2 : require('../../assets/noimage.png')"
                >
                  <v-row align="end" class="fill-height">
                    <v-col align-self="start" class="pa-0" cols="12">
                      <div class="camera-preview-box">
                        <!-- Local Camera WebCam -->
                        <div v-if="cameraMode === 'local'" style="width:100%;height:100%;" @click="onCapture()">
                          <vue-web-cam
                              ref="webcam1"
                              :device-id="deviceId"
                              width="100%"
                              @started="onStarted"
                              @stopped="onStopped"
                              @error="onError"
                              @cameras="onCameras"
                              @camera-change="onCameraChange"
                          />
                        </div>

                        <!-- Server Camera WebRTC Stream -->
                        <video
                            v-else-if="cameraMode === 'server'"
                            ref="videoPlates1"
                            autoplay
                            muted
                            playsinline
                            style="width:100%;height:100%;object-fit:cover;display:block;cursor:pointer;"
                            @click="onCapture()"
                            @loadedmetadata="onVideoLoaded"
                            @error="onVideoError"
                            @play="onVideoPlay"
                        ></video>
                      </div>
                    </v-col>
                  </v-row>
                </v-img>
                <!--                              <v-img-->
                <!--                                  width="100%"-->
                <!--                                  :src="imageCaptured3 !== '' ? imageCaptured3 : require('../../assets/noimage.png')"-->
                <!--                              ></v-img>-->
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
              v-show="!placas_abajo"
              cols="12"
              :sm="horizontal === true? 4 : 8"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-toolbar-title>
                  Placas
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <!-- Camera Mode Selector -->
                <v-row aling="center" class="mb-3">
                  <v-col cols="12">
                    <v-radio-group v-model="cameraMode" row @change="switchCameraMode">
                      <v-radio label="Cámara Local (SplitCam)" value="local"></v-radio>
                      <v-radio label="Servidor de Cámaras" value="server"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <!-- Local Camera (Legacy) -->
                <v-row aling="center" v-if="cameraMode === 'local'">
                  <h3>{{$t('select_video_device')}}</h3>
                </v-row>
                <v-row v-if="cameraMode === 'local'">
                  <v-select
                      outlined
                      small
                      v-model="camera"
                      :items="devices"
                      label="Placas"
                      item-text="label"
                      item-value="deviceId"
                  ></v-select>
                </v-row>

                <!-- Server Camera -->
                <v-row aling="center" v-if="cameraMode === 'server'">
                  <h3>Seleccionar Cámara del Servidor</h3>
                </v-row>
                <v-row v-if="cameraMode === 'server'">
                  <v-select
                      outlined
                      small
                      v-model="selectedServerCamera"
                      :items="serverCameras"
                      label="Cámara"
                      item-text="name"
                      return-object
                      @change="onServerCameraChange"
                  ></v-select>
                </v-row>

                {{$t('msg_captura_foto')}}
                <v-img
                    width="100%"
                    aspect-ratio="1"
                    :src="imageCaptured2 !== '' ? imageCaptured2 : require('../../assets/noimage.png')"
                >
                  <v-row align="end" class="fill-height">
                    <v-col align-self="start" class="pa-0" cols="12">
                      <div class="camera-preview-box">
                        <!-- Local Camera WebCam -->
                        <div v-if="cameraMode === 'local'" style="width:100%;height:100%;" @click="onCapture()">
                          <vue-web-cam
                              ref="webcam2"
                              :device-id="deviceId"
                              width="100%"
                              @started="onStarted"
                              @stopped="onStopped"
                              @error="onError"
                              @cameras="onCameras"
                              @camera-change="onCameraChange"
                          />
                        </div>

                        <!-- Server Camera WebRTC Stream -->
                        <video
                            v-else-if="cameraMode === 'server'"
                            ref="videoPlates2"
                            autoplay
                            muted
                            playsinline
                            style="width:100%;height:100%;object-fit:cover;display:block;cursor:pointer;"
                            @click="onCapture()"
                            @loadedmetadata="onVideoLoaded"
                            @error="onVideoError"
                            @play="onVideoPlay"
                        ></video>
                      </div>
                    </v-col>
                  </v-row>
                </v-img>
                <!--                              <v-img-->
                <!--                                  width="100%"-->
                <!--                                  :src="imageCaptured3 !== '' ? imageCaptured3 : require('../../assets/noimage.png')"-->
                <!--                              ></v-img>-->
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
              v-show="!placas_abajo"
              cols="12"
              :sm="horizontal === true? 8 : 12"
          >
            <v-tabs v-model="tabActivo" fixed-tabs background-color="primary">
              <v-tab>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="black"
                        dark
                        fab
                        icon
                        x-large
                        class="mr-2"
                        @click="getHorizontalVertical(), getPlatesWindow, dialogHorizontal = true"
                    >
                      <v-icon>mdi-cog-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('configuracion')}}</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <div v-show="photosCamera.length > 0">
                  <v-badge color="black">
                    <template v-slot:badge>
                      <span>{{photosCamera.length}}</span>
                    </template>
                    <span>{{$t('acceso_sin_codigo')}}</span>
                  </v-badge>
                </div>
                <div v-show="photosCamera.length === 0">
                  {{$t('acceso_sin_codigo')}}
                </div>
              </v-tab>
              <v-tab>
                <div v-show="qrCodes.length > 0">
                  <v-badge color="black">
                    <template v-slot:badge>
                      <span>{{qrCodes.length}}</span>
                    </template>
                    <span>{{$t('entradas_salidas')}}</span>
                  </v-badge>
                </div>
                <div v-show="qrCodes.length === 0">
                  {{$t('entradas_salidas')}}
                </div>
              </v-tab>
              <v-tab-item>
                <v-card class="mx-auto">
                  <v-card-text class="py-4 font-weight-bold">
                    <v-card>
                      <v-toolbar dark color="primary">
                        <v-icon v-if="getProfile.enable_parcel === false">mdi-truck</v-icon>
                        <v-checkbox hide-details class="shrink mr-2" v-if="getProfile.enable_parcel === false" v-model="bandParcel" color="black"></v-checkbox>
                        {{getProfile.enable_parcel === false ? $t('parcel_capital_letters') : ''}}
                        <v-btn text router to="/events"><v-icon>mdi-calendar-star</v-icon>{{$t('events')}}</v-btn>
                        <v-btn text router to="/delivery"><v-icon>mdi-moped</v-icon>Delivery</v-btn>
                        <v-spacer/>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="black"
                                dark
                                fab
                                icon
                                x-large
                                class="mr-2"
                                :loading="loadingTakePicture"
                                @click="takePicture1"
                            >
                              <v-icon>
                                mdi-camera
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{$t('capture_photo')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-show="getProfile.idHousingUnit === '3999d21c-555d-4be9-9179-c2cc34e2c825' || getProfile.idHousingUnit === '898109fd-bb69-4d2f-a223-5457810e2171'"
                                v-bind="attrs"
                                v-on="on"
                                color="black"
                                dark
                                fab
                                icon
                                x-large
                                class="mr-2"
                                :loading="loadingTakePicture"
                                @click="takePicture1INEBack"
                            >
                              <v-icon>
                                mdi-camera-retake
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{$t('capture_photo')}} Back</span>
                        </v-tooltip>
                      </v-toolbar>
                      <v-card-text>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="10"
                          >
                            <v-alert
                                v-show="bandMsgVacationMode"
                                type="error"
                                outlined
                            >
                              <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                            </v-alert>
                            <v-alert
                                v-show="bandInstructions"
                                type="info"
                                outlined
                            >
                              <strong>{{ msgInstructions }}</strong>
                            </v-alert>
                            <br>
                            <v-autocomplete
                                v-show="bandParcel"
                                v-model="idHouse2"
                                :search-input.sync="searchInput"
                                @change="searchInput=''"
                                prepend-icon="mdi-home-city"
                                name="idHouse2"
                                :item-text="example"
                                item-value="id"
                                :label="$t('casas')"
                                :placeholder="$t('search_by_street_house_number')"
                                :filter="customFilterNumber"
                                :error-messages="errors.house"
                                :items="houses"
                                no-data-text="Ningún Resultado"
                                outlined
                                multiple
                                chips
                                clearable
                                autocomplete="off"
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click="data.select"
                                    @click:close="remove(data.item)"
                                >
                                  {{ data.item.street }} {{data.item.number}}
                                </v-chip>
                              </template>
                              <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                  <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ data.item.street }} {{data.item.number}}</v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                                v-show="getProfile.booth_registration === false  && !bandParcel"
                                v-model="idHouse"
                                prepend-icon="mdi-home-city"
                                name="idHouse"
                                :item-text="getProfile.show_house_phones === false ? example : example2"
                                item-value="id"
                                :label="$t('casas')"
                                :placeholder="$t('search_by_house_number')"
                                :filter="customFilterNumber"
                                :error-messages="errors.house"
                                :items="houses"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                return-object
                                autocomplete="off"
                                @change="showMessageVacationMode"
                            >
                              <template v-slot:item="data" v-if="getProfile.show_house_phones === false">
                                <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                                <v-spacer/>
                                <v-btn-toggle>
                                  <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                  <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                  <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                    <v-icon>mdi-phone</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </template>
                              <template v-slot:item="data" v-else>
                                <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                                v-show="getProfile.booth_registration === true && !bandParcel"
                                v-model="idHouse"
                                prepend-icon="mdi-home-city"
                                name="idHouse"
                                :item-text="getProfile.show_house_phones === false ? example : example3"
                                item-value="id"
                                :label="$t('casas')"
                                :placeholder="$t('search_by_house_number_resident')"
                                :filter="customFilterNumberResident"
                                :error-messages="errors.house"
                                :items="houses"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                return-object
                                autocomplete="off"
                                @change="showMessageVacationMode"
                            >
                              <template v-slot:item="data">
                                <template v-if="getProfile.show_house_phones === false">
                                  <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                                  <v-spacer/>
                                  <v-btn-toggle>
                                    <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                      <v-icon>mdi-phone</v-icon>
                                    </v-btn>
                                    <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                      <v-icon>mdi-phone</v-icon>
                                    </v-btn>
                                    <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                      <v-icon>mdi-phone</v-icon>
                                    </v-btn>
                                  </v-btn-toggle>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                      {{data.item.fullname === '' ? 'n/a' : data.item.fullname}}
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="1"
                              class="text-right"
                          >
                            <v-btn
                                v-show="photosCamera.length !== 0"
                                icon
                                large
                                color="blue"
                                :loading="loading"
                                @click="indexTag = 0, imageCaptured = 'data:image/jpeg;base64,' + photosCamera[0].data, rotateBase64Image90deg(imageCaptured, true, 0, false)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        medium
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                      mdi-rotate-right
                                    </v-icon>
                                  </template>
                                  <span>Girar 90°</span>
                                </v-tooltip>
                            </v-btn>
                            <v-btn
                                v-show="photosCamera.length !== 0"
                                icon
                                large
                                color="primary"
                                :loading="loading"
                                @click="indexTag = 0, imageCaptured = 'data:image/jpeg;base64,' + photosCamera[0].data, rotateBase64Image180deg(imageCaptured, true, 0, false)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        medium
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                      mdi-rotate-right
                                    </v-icon>
                                  </template>
                                  <span>Girar 180°</span>
                                </v-tooltip>
                            </v-btn>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="1"
                              class="text-right"
                          >
                            <v-btn
                                v-show="photosCameraINEBack.length !== 0"
                                icon
                                large
                                color="blue"
                                :loading="loading"
                                @click="indexTag = 0, imageCapturedINEBack = 'data:image/jpeg;base64,' + photosCameraINEBack[0].data, rotateBase64Image90deg(imageCapturedINEBack, true, 0, true)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        medium
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                      mdi-rotate-right
                                    </v-icon>
                                  </template>
                                  <span>Girar 90°</span>
                                </v-tooltip>
                            </v-btn>
                            <v-btn
                                v-show="photosCameraINEBack.length !== 0"
                                icon
                                large
                                color="primary"
                                :loading="loading"
                                @click="indexTag = 0, imageCapturedINEBack = 'data:image/jpeg;base64,' + photosCameraINEBack[0].data, rotateBase64Image180deg(imageCapturedINEBack, true, 0, true)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        medium
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                      mdi-rotate-right
                                    </v-icon>
                                  </template>
                                  <span>Girar 180°</span>
                                </v-tooltip>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="5"
                          >
                            <div class="text--accent-1" v-show="getProfile.show_directory_guards === true && !bandParcel">
                              <div class="ml-6" v-show="idHouse.phone !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name1 === null) || (idHouse.name1 === '')) ? 'n/a' : idHouse.name1}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone2 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name2 === null) || (idHouse.name2 === '')) ? 'n/a' : idHouse.name2}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone2}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone3 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name3 === null) || (idHouse.name3 === '')) ? 'n/a' : idHouse.name3}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone3}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone4 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name4 === null) || (idHouse.name4 === '')) ? 'n/a' : idHouse.name4}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone4}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone5 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name5 === null) || (idHouse.name5 === '')) ? 'n/a' : idHouse.name5}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone5}}</strong></h2><br></div>
                              <div class="ml-6" v-show="idHouse.phone6 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name6 === null) || (idHouse.name6 === '')) ? 'n/a' : idHouse.name6}}</h5><h2>
                              <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone6}}</strong></h2><br></div><br>
                            </div>
                            <v-autocomplete
                                v-show="!bandParcel"
                                v-model="idService"
                                prepend-icon="mdi-tag-multiple"
                                name="idService"
                                :item-text="textServices"
                                item-value="name"
                                :label="$t('service_catalog')"
                                :placeholder="$t('search_by_name')"
                                :filter="customFilterService"
                                :items="services"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                autocomplete="off"
                            >
                              <template v-slot:item="data">
                                <strong>{{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                              </template>
                            </v-autocomplete>
                            <v-text-field
                                v-model="first_name"
                                prepend-icon="mdi-account"
                                name="first_name"
                                :label="$t('full_name')"
                                outlined
                                :error-messages="errors.name_guest"
                            >
                            </v-text-field>
                            <v-combobox
                                v-show="getProfile.idHousingUnit === '3999d21c-555d-4be9-9179-c2cc34e2c825' || getProfile.idHousingUnit === '9dbdc4ea-6909-4f99-95da-578b2f6de5f1' || getProfile.idHousingUnit === '8c19e21b-3e74-4405-aeb3-297f9f573ab1'"
                                v-model="resident_name"
                                name="resident_name"
                                outlined
                                clearable
                                prepend-icon="mdi-account-check"
                                item-text="fullname"
                                item-value="fullname"
                                @change="onChangeComboBoxResidents"
                                :label="$t('who_authorized')"
                                :items="residents"
                                autocomplete="off"
                                :error-messages="errors.resident_name"
                            ></v-combobox>
                            <v-textarea
                                v-model="notes"
                                autocomplete="on"
                                prepend-icon="mdi-text"
                                name="notes"
                                :placeholder="$t('placeholder_notas')"
                                :label="$t('Notas')"
                                outlined
                                :error-messages="errors.comments"
                            ></v-textarea>
                            <div align="center">
                              <v-btn
                                  v-show="photosCamera.length !== 0 || photosCameraINEBack.length !== 0"
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  :loading="loading"
                                  :disabled="loading"
                                  @click="indexTag = 0, otro()">
                                {{$t('acceso')}}
                              </v-btn>
                              <v-checkbox
                                v-if="bandParcel === false"
                                v-model="bandAdditionalPersonCode"
                                name="bandAdditionalPersonCode"
                                :label="$t('msg_additional_person')"
                              >
                              </v-checkbox>
                              <v-btn
                                color="primary"
                                v-if="bandAdditionalPersonCode === true && bandParcel === false"
                                @click="cleanAdditionalPersonFields(), dialogAdditionalPersonCode = true"
                              >{{$t('additional_person')}}</v-btn>
                            </div>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="7"
                          >
                            <v-row>
                              <v-img
                                  v-if="photosCamera.length !== 0"
                                  :src="'data:image/jpeg;base64,' + photosCamera[0].data"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                              <v-img
                                  v-else
                                  :src="require('../../assets/noimage.png')"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                            </v-row>
                            <v-row v-show="getProfile.idHousingUnit === '3999d21c-555d-4be9-9179-c2cc34e2c825' || getProfile.idHousingUnit === '898109fd-bb69-4d2f-a223-5457810e2171'">
                              <v-img
                                  v-if="photosCameraINEBack.length !== 0"
                                  :src="'data:image/jpeg;base64,' + photosCameraINEBack[0].data"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                              <v-img
                                  v-else
                                  :src="require('../../assets/noimage.png')"
                                  position="center center"
                                  class="grey lighten-2 mb-4"
                              ></v-img>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12">
                            <div v-if="bandAdditionalPersonCode === true && bandParcel === false">
                              <v-data-table
                                  :headers="headers"
                                  :items="additionalPersons"
                                  :footer-props="{
                                        itemsPerPageOptions: [
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}
                                        ],
                                        itemsPerPageText: $t('filas_por_pagina')
                                    }"
                                  :no-data-text="$t('no_records_yet')"
                                  class="elevation-1"
                              >
                                <template v-slot:item.full_name="{ item }">
                                  {{ item.full_name}}
<!--                                  <div v-if="errores_ter[residentes.indexOf(item)]"  class="red&#45;&#45;text">{{errores_ter[residentes.indexOf(item)].first_name}}</div>-->
                                </template>
<!--                                <template v-slot:item.photo="{ item }">-->
<!--                                  {{ item.photo}}-->
<!--&lt;!&ndash;                                  <div v-if="errores_ter[residentes.indexOf(item)]" class="red&#45;&#45;text">{{errores_ter[residentes.indexOf(item)].last_name}}</div>&ndash;&gt;-->
<!--                                </template>-->
                                <template v-slot:item.action="{ item }">
                                  <v-icon
                                      medium
                                      color="grey"
                                      class="mr-2"
                                      @click="editResident(item)"
                                  >
                                    mdi-pencil
                                  </v-icon>
                                  <v-icon
                                      medium
                                      color="red"
                                      @click="deleteResident(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                              </v-data-table>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
<!--                    <v-card v-show="photosCamera.length === 0">-->
<!--                      <v-card-text class="text-center">-->
<!--                        <v-btn-->
<!--                            color="black"-->
<!--                            dark-->
<!--                            fab-->
<!--                            x-large-->
<!--                            :loading="loadingTakePicture"-->
<!--                            @click="takePicture1"-->
<!--                        >-->
<!--                          <v-icon>mdi-camera</v-icon>-->
<!--                        </v-btn>-->
<!--                        <v-spacer/>-->
<!--                        <h2>{{$t('no_registros_pase_salida')}}</h2>-->
<!--                      </v-card-text>-->
<!--                    </v-card>-->
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card class="mx-auto">
                  <v-card-text class="py-0">
                    <v-timeline dense v-if="qrCodes.length !== 0">
                      <v-slide-x-transition
                          group
                          hide-on-leave
                      >
                        <v-timeline-item
                            v-for="(item, index) in qrCodes"
                            :key="item.data"
                            small
                            fill-dot
                        >
                          <!-- MENSAJE msg_vacation_mode_activate -->
                          <v-card v-if="item.status === -5">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_vacation_mode_activate')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE msg_canceled_invitation -->
                          <v-card v-if="item.status === -3">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_canceled_invitation')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- REGISTRAR ENTRADA/SALIDA TRABAJADORES -->
                          <v-card v-else-if="item.status === -1">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <h4>{{$t('info_residente')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-alert
                                      v-show="item.info.resident.vacation_mode && !item.info.resident.allow_access_residents"
                                      type="error"
                                  >
                                    <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                  </v-alert>
                                  <v-alert
                                      v-show="item.info.resident.instructions !== '' && item.info.resident.instructions !== null"
                                      type="info"
                                  >
                                    <strong>{{ item.info.resident.instructions }}</strong>
                                  </v-alert>
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.resident.idUser.idFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('residente')}}:
                                          </th>
                                          <td>
                                            {{ item.info.resident.idUser.first_name}}
                                            {{ item.info.resident.idUser.last_name}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.resident.street}} {{item.info.resident.numberHouse}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{  item.info.resident.idUser.cellNumber}}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer/>
                              <v-btn
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="deleteItem(index)">
                                {{$t('acceso')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <v-card v-else-if="item.status === 0">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('mensaje_qr_no_valido')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 1">
                            <v-toolbar dark color="orange">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="orange"
                                  border="left"
                                  type="warning"
                                  outlined
                              >
                                {{$t('mensaje_acceso_completo')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <v-card v-else-if="item.status === 2">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <br>
                              <v-alert
                                  v-show="item.info.invitation.supplier"
                                  type="info"
                                  outlined
                              >
                                <strong>{{$t('supplier_mode')}}</strong>{{$t('msg_supplier')}}
                              </v-alert>
                              <v-alert
                                  v-show="item.info.invitation.vacation_mode && !item.info.invitation.allow_access_visitors"
                                  type="error"
                              >
                                <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                              </v-alert>
                              <v-alert
                                  v-show="item.info.invitation.instructions !== '' && item.info.invitation.instructions !== null"
                                  type="info"
                              >
                                <strong>{{ item.info.invitation.instructions }}</strong>
                              </v-alert>
                              <br>
                              <v-layout row wrap>
                                <h4>{{$t('info_invitado')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.invitation.guestIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('Visitante')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestFName}}
                                            {{ item.info.invitation.guestLName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('Asunto')}}
                                          </th>
                                          <td>
                                            {{ item.info.invitation.subject}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('dias_validos')}}:
                                          </th>
                                          <td>
                                            {{item.info.invitation.diary.includes('0') === true ? $t('Lunes') : ''}}
                                            {{item.info.invitation.diary.includes('1') === true ? $t('Martes') : ''}}
                                            {{item.info.invitation.diary.includes('2') === true ? $t('Miercoles') : ''}}
                                            {{item.info.invitation.diary.includes('3') === true ? $t('Jueves') : ''}}
                                            {{item.info.invitation.diary.includes('4') === true ? $t('Viernes') : ''}}
                                            {{item.info.invitation.diary.includes('5') === true ? $t('Sabado') : ''}}
                                            {{item.info.invitation.diary.includes('6') === true ? $t('Domingo') : ''}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('fecha_expiracion')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.expiration }}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-layout v-show="item.info.invitation.correction_request === false" align-center justify-center row wrap>
                                  <v-btn
                                      large
                                      color="error"
                                      @click="index_correction_request = index, id_user_settings = item.info.invitation.id_user_settings, errores = [], first_name_correction = item.info.invitation.guestFName, last_name_correction = item.info.invitation.guestLName, msg_photograph_blurred = true, dialog_correction_request = true"
                                  >{{$t('send_correction_request')}}
                                  </v-btn>
                              </v-layout>
                              <v-layout v-show="item.info.invitation.correction_request === true" align-center justify-center row wrap>
                                  <v-btn
                                      disabled
                                      large
                                      color="error"
                                  >{{$t('data_correction_sent')}}
                                  </v-btn>
                              </v-layout>
                              <v-layout v-show="getProfile.enable_host_info" row wrap>
                                <h4>{{$t('info_anfitrion')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          v-if="getProfile.enable_ine_photo"
                                          :src="item.info.invitation.hostIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                      <v-img
                                          v-else
                                          :src="item.info.invitation.avatarHost"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('residente')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostFirstName}}
                                            {{ item.info.invitation.hostLastName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="text-center">
                              <v-text-field
                                  class="mt-7"
                                  v-model="comments"
                                  name="comments"
                                  outlined
                                  autocomplete="off"
                                  maxlength="300"
                                  prepend-icon="mdi-text"
                                  :label="$t('Notas')"
                              ></v-text-field>
                              ---
                              <v-btn
                                  x-large
                                  color="primary"
                                  @click="otro2(index, item.data)">
                                {{$t('acceso')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <!-- REGISTRAR SALIDA DE INVITACION -->
                          <v-card v-else-if="item.status === 3">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <h4>{{$t('info_invitado')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.invitation.guestIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('Visitante')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestFName}}
                                            {{ item.info.invitation.guestLName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.guestCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('Asunto')}}
                                          </th>
                                          <td>
                                            {{ item.info.invitation.subject}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('dias_validos')}}:
                                          </th>
                                          <td>
                                            {{item.info.invitation.diary.includes('0') === true ? $t('Lunes') : ''}}
                                            {{item.info.invitation.diary.includes('1') === true ? $t('Martes') : ''}}
                                            {{item.info.invitation.diary.includes('2') === true ? $t('Miercoles') : ''}}
                                            {{item.info.invitation.diary.includes('3') === true ? $t('Jueves') : ''}}
                                            {{item.info.invitation.diary.includes('4') === true ? $t('Viernes') : ''}}
                                            {{item.info.invitation.diary.includes('5') === true ? $t('Sabado') : ''}}
                                            {{item.info.invitation.diary.includes('6') === true ? $t('Domingo') : ''}}
                                          </td>
                                        </tr>
                                        <tr v-if="item.info.invitation.typeInv === 2">
                                          <th>
                                            {{$t('fecha_expiracion')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.expiration }}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-layout v-show="getProfile.enable_host_info" row wrap>
                                <h4>{{$t('info_anfitrion')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          v-if="getProfile.enable_ine_photo"
                                          :src="item.info.invitation.hostIdFront"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                      <v-img
                                          v-else
                                          :src="item.info.invitation.avatarHost"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            {{$t('residente')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostFirstName}}
                                            {{ item.info.invitation.hostLastName}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('celular')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.hostCellphone}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            {{$t('numero_casa')}}:
                                          </th>
                                          <td>
                                            {{ item.info.invitation.street}} {{item.info.invitation.numberHouse}}
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="text-xs-center">
                              <v-spacer/>
                              <v-btn
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="update_acceso(index, item.access)">
                                {{$t('registrar_salida')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <!-- MENSAJE msg_out_date -->
                          <v-card v-else-if="item.status === 4">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE msg_out_date2 -->
                          <v-card v-else-if="item.status === 5">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date2')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE msg_out_date3 -->
                          <v-card v-else-if="item.status === 6">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date3')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- REGISTRAR ENTRADA/SALIDA TRABAJADORES -->
                          <v-card v-else-if="item.status === 10 || item.status === 11">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <h4>{{$t('info_worker')}}</h4>
                                <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                  <v-alert
                                      v-show="item.info.worker.vacation_mode && !item.info.worker.allow_access_workers"
                                      type="error"
                                  >
                                    <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                  </v-alert>
                                  <v-alert
                                      v-show="item.info.worker.instructions !== '' && item.info.worker.instructions !== null"
                                      type="info"
                                  >
                                    <strong>{{ item.info.worker.instructions }}</strong>
                                  </v-alert>
                                  <v-layout row wrap>
                                    <v-flex sm12 md6>
                                      <v-img
                                          :src="item.info.worker.avatar"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex sm12 md6>
                                      <table>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('worker')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.first_name}}
                                              {{ item.info.worker.last_name}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('numero_casa')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.street}} {{item.info.worker.numberHouse}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('check_in_time')}}
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.check_in_time}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('check_out_time')}}
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.check_out_time}}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('fecha_inicial')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.initial_date }}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('fecha_expiracion')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3>
                                              {{ item.info.worker.final_date }}
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>
                                            <h3>
                                              {{$t('dias_validos')}}:
                                            </h3>
                                          </th>
                                          <td>
                                            <h3 v-if="item.info.worker.diary.includes('0') === true">
                                              {{ $t('Lunes') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('1') === true">
                                              {{ $t('Martes') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('2') === true">
                                              {{ $t('Miercoles') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('3') === true">
                                              {{ $t('Jueves') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('4') === true">
                                              {{ $t('Viernes') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('5') === true">
                                              {{ $t('Sabado') }}
                                            </h3>
                                            <h3 v-if="item.info.worker.diary.includes('6') === true">
                                              {{ $t('Domingo') }}
                                            </h3>
                                          </td>
                                        </tr>
                                      </table>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions class="text-center" v-if="item.status === 10">
                              <v-text-field
                                  class="mt-8"
                                  v-model="comments"
                                  name="comments"
                                  outlined
                                  autocomplete="off"
                                  maxlength="300"
                                  prepend-icon="mdi-text"
                                  :label="$t('Notas')"
                              ></v-text-field>
                              ---
                              <v-btn
                                  v-if="item.status === 10"
                                  x-large
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="item.status === 11"
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('registrar_salida')}}
                              </v-btn>
                            </v-card-actions>
                            <v-card-actions class="text-center" v-else>
                              <v-spacer/>
                              <v-btn
                                  v-if="item.status === 10"
                                  x-large
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="item.status === 11"
                                  medium
                                  class="ml-2 mt-5"
                                  color="primary"
                                  @click="create_worker_access(index, item.data, item.status)">
                                {{$t('registrar_salida')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <!-- MENSAJE msg_out_date_worker0 -->
                          <v-card v-else-if="item.status === 12">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date_worker0')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE msg_out_date_worker1 -->
                          <v-card v-else-if="item.status === 13">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_out_date_worker1')}}</v-alert>
                            </v-card-text>
                          </v-card>
                          <!-- LISTA DE INVITADOS A EVENTO-->
                          <v-card v-else-if="item.status === 20">
                            <v-toolbar dark color="primary">
                              <v-toolbar-title>{{$t('event_data')}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <div class="heading text-justify black--text">
                                    <p>
                                      <br><strong>{{$t('event_name')}}: <BIG><U>{{item.info.event.name}}</U></BIG></strong><br>
                                      <strong>{{$t('direccion')}}: <BIG>{{item.info.event.address}}</BIG></strong><br>
                                      <strong>{{$t('Fecha')}}: <BIG>{{item.info.event.date}}</BIG></strong>&nbsp;&nbsp;&nbsp;
                                      <strong>{{$t('event_time')}}: <BIG>{{item.info.event.time}}</BIG></strong><br>
                                    </p>
                                  </div>
                                </v-flex>
                                <v-flex xs12>
                                  <table style="width:100%">
                                  <tr>
                                    <th>{{ $t('invitados') }}</th>
                                    <th>{{ $t('estado') }}</th>
                                  </tr>
                                  <tr v-for="item3 in item.info.guests" :key="item3.id">
                                    <td><strong><BIG>{{ item3.fullName }}</BIG></strong></td>
                                    <td v-if="item3.status === 0">
                                      <v-btn
                                          @click="checkInGuestByEvent(item.info.event, item3), deleteItem(index)"
                                          color="primary">
                                          {{$t('complete_register')}}
                                      </v-btn>
                                    </td>
                                    <td v-else>
                                      <v-icon color="primary">mdi-check</v-icon>{{$t('adentro')}}
                                    </td>
                                  </tr>
                                </table>
                                  <!-- <v-data-table
                                      :headers="headersEvent"
                                      :hide-default-footer="true"
                                      :items="item.info.guests"
                                      :footer-props="{
                                                        itemsPerPageOptions: [
                                                            {text: '5', value: 5},
                                                            {text: '10', value: 10},
                                                            {text: '25', value: 25},
                                                            {text: this.$t('todos'), value: -1}
                                                        ],
                                                        itemsPerPageText: $t('filas_por_pagina')
                                                    }"
                                      :no-data-text="$t('no_records_yet')"
                                      class="elevation-1"
                                  >
                                  </v-data-table> -->
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                          <!-- MENSAJE EVENTO CANCELADO -->
                          <v-card v-else-if="item.status === 21">
                            <v-toolbar dark color="red">
                              <v-toolbar-title>{{item.label}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="white"
                                      dark
                                      class="mr-2"
                                      @click="deleteItem(index)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span>{{$t('delete')}}</span>
                              </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                              <v-alert
                                  color="red"
                                  border="left"
                                  type="error"
                                  outlined
                              >
                                {{$t('msg_event_canceled')}}</v-alert>
                            </v-card-text>
                          </v-card>
                        </v-timeline-item>
                      </v-slide-x-transition>
                    </v-timeline>
                    <v-timeline v-else>
                      <v-timeline-item >
                        {{$t('no_registros_pase_salida')}}
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { WebCam } from 'vue-web-cam'
import store from '@/store'
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'

let nextId = 1
const COLORS = [
  'info',
  'warning',
  'error',
  'success'
]
const ICONS = {
  info: 'mdi-qrcode',
  warning: 'mdi-camera',
  error: 'mdi-alert-circle',
  success: 'mdi-check-circle'
}

export default {
  name: 'checkin_checkout_qr2',
  components: {
    'vue-web-cam': WebCam
  },
  data () {
    return {
      dialogHorizontal: false,
      horizontal: true,
      placas_abajo: true,
      // access no code
      camera: null,
      devices: [],
      deviceId: null,
      imageCaptured2: '',
      imageCaptured3: '',
      dialogData: false,
      houses: [],
      errors: [],
      first_name: '',
      celular: '',
      notes: '',
      idHouse: {
        id: ''
      },
      imageCaptured: '',
      imageCapturedINEBack: '',
      indexTag: -1,
      // access no code
      tab: null,
      activar_camara: true,
      qr_code: '',
      error: '',
      valido: false,
      a_qr_code: '',
      salida: false,
      entrada: false,
      entradaResidente: false,
      data_access: [],
      errores_guard: '',
      head_color: '',
      info_invitation: [],
      dialog: false,
      comments: '',
      dialog_errores: false,
      dialogInitial: false,
      loading: false,
      loadingTakePicture: false,
      guardHouse: null,
      bandMsgVacationMode: false,
      bandInstructions: false,
      msgInstructions: '',
      guardHouses: [],
      labelDevice: '',
      // Example
      interval: null,
      items: [
        {
          id: 1,
          color: 'info',
          icon: ICONS.info
        }
      ],
      nonce: 2,
      rotateimage: '',
      idService: '',
      tabActivo: 0,
      services: [],
      // VARIABLES CORRECCION DE DATOS
      dialog_correction_request: false,
      first_name_correction: '',
      last_name_correction: '',
      id_user_settings: 0,
      errores: [],
      loading_correction_request: false,
      msg_photograph_blurred: true,
      index_correction_request: -1,
      // VARIABLES CORRECCION DE DATOS

      bandParcel: false,
      // VARIABLES AGREGAR ACOMPANANTES
      dialogAdditionalPersonCode: false,
      full_name_additional_person: '',
      bandAdditionalPersonCode: false,
      headers: [],
      additionalPersons: [],
      editedIndex: -1,
      edit: false,
      editedItem: {
        full_name: '',
        data: '',
        classification: '',
        label: ''
      },
      defaultItem: {
        full_name: '',
        data: '',
        classification: '',
        label: ''
      },
      idHouse2: [],
      searchInput: '',
      imageCapturedAdditional: '',
      // VARIABLES AGREGAR ACOMPANANTES
      residents: [],
      resident_name: '',
      headersEvent: [],
      idGuestByEvent: null,
      idGuestByDelivery: null,
      // Camera Server Integration
      cameraMode: 'local', // 'local' or 'server'
      serverIP: localStorage.getItem('camera_server_ip') || '127.0.0.1:7000',
      serverCameras: [],
      selectedServerCamera: null,
      peerConnection: null,
      cameraAPI: null,
      videoElementPlates: null,
      webrtcNegotiating: false,
      // Video tracking
      isVideoPlaying: false,
      videoLoadRetries: 0,
      maxVideoLoadRetries: 3
    }
  },
  created () {
    this.getHorizontalVertical()
    this.getPlatesWindow()
    this.tabActivo = parseInt(this.$route.params.tab)
    this.getHouses()
    this.getServices()
    console.log(this.$route.params)
    console.log('Tamaño =', Object.keys(this.$route.params).length)
    if (Object.keys(this.$route.params).length > 2) {
      this.tabActivo = 0
      if (this.$route.params.type === 0) { // EVENTO
        this.first_name = this.$route.params.fullNameGuest + ' (EVENTO)'
        this.idHouse.id = this.$route.params.idHouse
        this.idGuestByEvent = this.$route.params.idGuestByEvent
        this.notes = this.$route.params.eventName
      } else { // DELIVERY
        this.idHouse.id = this.$route.params.idHouse
        this.idGuestByDelivery = this.$route.params.idGuestByDelivery
        this.notes = this.$route.params.notes
        this.first_name = this.$route.params.personName
      }
    }
  },
  computed: {
    device () {
      return this.devices.find(n => n.deviceId === this.deviceId)
    },
    ...mapState(['qrDevices', 'qrCodes', 'photosCamera', 'photosCameraAdditionalPerson', 'photosCameraINEBack']),
    ...mapGetters(['getProfile'])
  },
  watch: {
    camera (id) {
      this.deviceId = id
    },
    devices () {
      console.log('Hola')
      // Once we have a list select the first one
      const [first, ...tail] = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      } else {
        this.camera = tail.deviceId
        this.deviceId = tail.deviceId
      }
    },
    photosCamera () {
      if (this.photosCamera.length !== 0) {
        console.log('valor de fullTextAnnotation OCR = ', this.photosCamera[0].fullTextAnnotation)
        if (this.photosCamera[0].fullTextAnnotation !== undefined) {
          console.log('DEFINIDO')
          this.first_name = this.photosCamera[0].fullTextAnnotation
        } else {
          console.log('UNDEFINIDO')
        }
      }
    }
  },
  beforeUpdate () {
    this.headersEvent = [
      {
        text: this.$t('invitados'),
        align: 'left',
        sortable: true,
        value: 'fullName'
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'status'
      }
    ]
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'center',
        sortable: true,
        value: 'full_name'
      }
    ]
  },
  beforeDestroy () {
    this.stop()
    this.closeServerCamera()
  },
  methods: {
    checkInGuestByEvent (dataEvent, item) {
      this.tabActivo = 0
      this.first_name = item.fullName + ' (EVENTO)'
      this.idHouse = {
        id: dataEvent.idHouse
      }
      this.idGuestByEvent = item.id
      this.notes = dataEvent.name
    },
    addItem (name) {
      const newItem = {
        id: nextId++,
        fullname: name
      }
      this.residents.push(newItem)
      return newItem
    },
    onChangeComboBoxResidents (entry) {
      if (typeof entry === 'string' && entry.trim()) {
        const item = this.residents.find(item => item.fullname === entry)
        if (item) {
          this.resident_name = item
        } else {
          this.resident_name = this.addItem(entry)
        }
      }
    },
    remove: function (item) {
      console.log(this.idHouse2)
      console.log(this.idHouse2[0])
      const index = this.idHouse2.indexOf(item.id)
      console.log(index)
      if (index >= 0) this.idHouse2.splice(index, 1)
    },
    createAccessNoCode () {
      console.log('idHouse = ', this.idHouse)
      console.log('idHouse2 = ', this.idHouse2)
      this.errors = []
      const words = this.first_name.trim().split(/\s+/)
      if (words.length < 2 || words[0] === '' || words[1] === '') {
        this.errors = {
          name_guest: [this.$t('error_name_min_two_words')]
        }
        return
      }
      if (this.bandParcel === true) {
        this.createManyAccessNoCode()
      } else {
        this.createAccessWithoutCode()
      }
    },
    createManyAccessNoCode () {
      this.loading = true
      this.errors = []
      console.log('TAM ====> ', this.idHouse2.length)
      var bodyFormData = new FormData()
      var fileImageFront = null

      for (let i = 0; i < this.idHouse2.length; i++) {
        const newID = this.$uuid.v4()
        bodyFormData.append('housing_unit', this.getProfile.idHousingUnit)
        bodyFormData.append('house', this.idHouse2[i])
        bodyFormData.append('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))
        bodyFormData.append('name_guest', this.first_name)
        bodyFormData.append('comments', this.notes)
        if (this.imageCaptured3 !== '' && this.imageCaptured3.length > 6) {
          fileImageFront = this.dataURLtoFile(this.imageCaptured3, 'photo' + newID + '.jpeg')
        }
        bodyFormData.append('photo', fileImageFront)
      }
      console.log(bodyFormData)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/access_no_code_many_create/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('access_success'))
          this.deleteItemPhoto(this.indexTag)
          this.deleteItemPhotoINEBack(this.indexTag)
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    changeHorizontalVertical () {
      console.log('Horizontal = ', this.horizontal)
      localStorage.setItem('horizontal', this.horizontal)
    },
    getHorizontalVertical () {
      console.log('Hola    .....')
      if (localStorage.getItem('horizontal') === null || JSON.parse(localStorage.getItem('horizontal')) === true) {
        this.horizontal = true
      } else {
        this.horizontal = false
      }
    },
    changePlatesWindow () {
      console.log('PlatesWindow = ', this.placas_abajo)
      localStorage.setItem('placas_abajo', this.placas_abajo)
    },
    getPlatesWindow () {
      console.log('Hola    .....')
      if (localStorage.getItem('placas_abajo') === null || JSON.parse(localStorage.getItem('placas_abajo')) === true) {
        this.placas_abajo = true
      } else {
        this.placas_abajo = false
      }
    },
    addResident () {
      this.editedItem.full_name = this.editedItem.full_name
      this.editedItem.data = this.photosCameraAdditionalPerson[0].data
      this.editedItem.classification = this.photosCameraAdditionalPerson[0].classification
      this.editedItem.label = this.photosCameraAdditionalPerson[0].label
      if (this.editedIndex > -1) {
        Object.assign(this.additionalPersons[this.editedIndex], this.editedItem)
      } else {
        this.additionalPersons.push(this.editedItem)
        console.log(this.editedItem)
        console.log('Resident Added')
      }
      this.dialogAdditionalPersonCode = false
    },
    editResident (item) {
      let aux = []
      // console.log('ITEM = ', item)
      this.editedIndex = this.additionalPersons.indexOf(item)
      // console.log('INDEX EDIT ITEM = ', this.editedIndex)
      this.editedItem = Object.assign({}, item)
      aux.push(this.editedItem)
      localStorage.setItem('listStorePhotosCameraAdditionalPerson', JSON.stringify(aux))
      this.$store.commit('setPhotosAdditionalPerson', JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson')))
      this.dialogAdditionalPersonCode = true
    },
    deleteResident (aResident) {
      const index = this.additionalPersons.indexOf(aResident)
      confirm('¿Está seguro de eliminar el Registro de ' + aResident.full_name + '?.\nEsta Acción no se puede deshacer!') && this.additionalPersons.splice(index, 1)
    },
    send_correction_request () {
      this.errores = []
      this.loading_correction_request = true
      console.log(this.qr_code)
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/user/update/correction_request/' + this.id_user_settings,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          first_name: this.first_name_correction,
          last_name: this.last_name_correction
        }
      }
      axios(config)
        .then(response => {
          this.loading_correction_request = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('registro_exito'))
          this.dialog_correction_request = false
          this.updateItemCorrectionRequest(this.index_correction_request)
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading_correction_request = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getDirectoryResidents (idHouse) {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/residents_fullname/all/' + idHouse,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          console.log(response.status)
          console.log(response.data)
          this.residents = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showMessageVacationMode () {
      this.resident_name = ''
      this.residents = []
      console.log('Fill Houses')
      console.log(this.idHouse)
      if (this.idHouse === undefined) {
        this.idHouse = {
          id: ''
        }
        this.bandMsgVacationMode = false
        this.bandInstructions = false
        this.msgInstructions = ''
      } else {
        this.getDirectoryResidents(this.idHouse.id)
        if (this.idHouse.vacation_mode && !this.idHouse.allow_access_visitors) {
          this.bandMsgVacationMode = true
        } else {
          this.bandMsgVacationMode = false
        }
        if (this.idHouse.instructions !== '' && this.idHouse.instructions !== null) {
          this.bandInstructions = true
          this.msgInstructions = this.idHouse.instructions
        } else {
          this.bandInstructions = false
          this.msgInstructions = ''
        }
      }
    },
    deleteHeadFromImages (imagen) {
      return imagen.replace('data:image/jpeg;base64,', '')
    },
    async mergeImagesCanvas (base64A, base64B) {
      const toUrl = b => b.startsWith('data:') ? b : 'data:image/jpeg;base64,' + b
      const loadImg = src => new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = () => reject(new Error('No se pudo cargar imagen'))
        img.src = src
      })
      const [img1, img2] = await Promise.all([loadImg(toUrl(base64A)), loadImg(toUrl(base64B))])
      const canvas = document.createElement('canvas')
      canvas.width = Math.max(img1.width, img2.width)
      canvas.height = img1.height + img2.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img1, 0, 0)
      ctx.drawImage(img2, 0, img1.height)
      return canvas.toDataURL('image/jpeg')
    },
    async mergeTwoImages (imageOne, imageTwo) {
      return this.mergeImagesCanvas(imageOne, imageTwo)
    },
    async asyncCall (imagenAux, imagenAux2) {
      this.imageCaptured3 = await this.mergeImagesCanvas(imagenAux2, imagenAux)
    },
    onCapture () {
      if (this.cameraMode === 'local') {
        const webcam = this.placas_abajo ? this.$refs.webcam1 : this.$refs.webcam2
        if (webcam) this.imageCaptured2 = webcam.capture()
      } else if (this.cameraMode === 'server') {
        // Capturar frame del video WebRTC usando canvas
        const videoEl = this.$refs.videoPlates1 || this.$refs.videoPlates2
        if (!videoEl) return
        const canvas = document.createElement('canvas')
        canvas.width = videoEl.videoWidth || 640
        canvas.height = videoEl.videoHeight || 480
        canvas.getContext('2d').drawImage(videoEl, 0, 0, canvas.width, canvas.height)
        this.imageCaptured2 = canvas.toDataURL('image/jpeg')
      }
    },
    getPlatesCar () {
      var bodyFormData = new FormData()
      // var fileImageFront = null

      // const newID = this.$uuid.v4()
      this.imageCaptured = 'data:image/jpeg;base64,' + this.photosCamera[0].data
      if (this.imageCaptured !== '' && this.imageCaptured.length > 6) {
        // fileImageFront = this.dataURLtoFile(this.imageCaptured, 'photo' + newID + '.jpeg')
        bodyFormData.append('upload', this.imageCaptured)
        bodyFormData.append('regions', 'mx') // Change to your country
      }
      console.log(bodyFormData)
      const config = {
        method: 'post',
        url: 'https://api.platerecognizer.com/v1/plate-reader/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': 'Token ' + 'c5e7c0f48b04989316c416625c15e31a068546e7'
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          if (ok.data.results.length > 0) {
            console.log('Placas del carro = ')
            console.log(ok.data.results[0].plate)
          } else {
            console.log('Sin placas')
          }
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    async otro () {
      // console.log('Valor de photosCamera ')
      // console.log(this.photosCamera)
      // console.log('Valor de photosCameraINEBack ')
      // console.log(this.photosCameraINEBack)
      if (this.imageCaptured2 === '') {
        await this.onCapture()
      }
      if (this.photosCameraINEBack.length !== 0 && this.photosCamera.length !== 0) { // Caso ambos lados de INE
        console.log('Caso Ambos lados de la INE')
        let imageINEFront = ''
        let imageINEBack = ''
        let imagenMergeINE = ''
        let imagenAux = ''
        let imagenPlates = ''
        this.imageCaptured = 'data:image/jpeg;base64,' + this.photosCamera[0].data
        this.imageCapturedINEBack = 'data:image/jpeg;base64,' + this.photosCameraINEBack[0].data
        imageINEFront = this.deleteHeadFromImages(this.imageCaptured)
        imageINEBack = this.deleteHeadFromImages(this.imageCapturedINEBack)
        imagenMergeINE = await this.mergeTwoImages(imageINEFront, imageINEBack)
        imagenAux = this.deleteHeadFromImages(imagenMergeINE)
        imagenPlates = this.deleteHeadFromImages(this.imageCaptured2)
        await this.asyncCall(imagenAux, imagenPlates)
        console.log('Caso Ambos lados de la INE')
      } else {
        if (this.photosCameraINEBack.length === 0 && this.photosCamera.length !== 0) { // Caso lado INE Frente
          console.log('Caso INE Frente')
          let imageINEFront = ''
          let imagenPlates = ''
          this.imageCaptured = 'data:image/jpeg;base64,' + this.photosCamera[0].data
          imageINEFront = this.deleteHeadFromImages(this.imageCaptured)
          imagenPlates = this.deleteHeadFromImages(this.imageCaptured2)
          await this.asyncCall(imageINEFront, imagenPlates)
          console.log('Caso INE Frente')
        } else { // Caso lado INE Atras
          console.log('Caso INE Atras')
          let imageINEBack = ''
          let imagenPlates = ''
          this.imageCapturedINEBack = 'data:image/jpeg;base64,' + this.photosCameraINEBack[0].data
          imageINEBack = this.deleteHeadFromImages(this.imageCapturedINEBack)
          imagenPlates = this.deleteHeadFromImages(this.imageCaptured2)
          await this.asyncCall(imageINEBack, imagenPlates)
          console.log('Caso INE Atras')
        }
      }
      this.createAccessNoCode()
    },
    async otro2 (index, aQr) {
      if (this.imageCaptured2 === '') {
        console.log('NO CAPTURADO')
        await this.onCapture()
      } else {
        console.log('YA CAPTURADO')
      }
      this.create_acceso(index, aQr)
    },
    onStarted (stream) {
      console.log('On Started Event', stream)
      // this.band = true
    },
    onStopped (stream) {
      console.log('On Stopped Event', stream)
    },
    onStart () {
      this.$refs.webcam.start()
    },
    onStop () {
      this.$refs.webcam.stop()
    },
    onError (error) {
      console.log('On Error Event', error)
    },
    onCameras (cameras) {
      this.devices = cameras
      console.log('On Cameras Event', cameras)
    },
    onCameraChange (deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
      console.log('On Camera Change Event', deviceId)
    },
    // Camera Server Integration Methods
    initCameraAPI () {
      const axios = require('axios')
      const baseURL = `http://${this.serverIP}`
      this.cameraAPI = axios.create({
        baseURL: baseURL,
        headers: { 'Content-Type': 'application/json' },
        timeout: 5000
      })
    },
    async loadServerCameras () {
      try {
        if (!this.cameraAPI) {
          this.initCameraAPI()
        }

        // Step 1: Get list of available cameras
        const camerasResponse = await this.cameraAPI.get('/api/cameras')
        this.serverCameras = camerasResponse.data
        console.log('Server cameras loaded:', this.serverCameras)

        // Step 2: Get streams status to get the correct aliases
        const streamsResponse = await this.cameraAPI.get('/api/streams')
        const streamsData = streamsResponse.data.streams || streamsResponse.data

        // Map camera data with stream aliases
        if (Array.isArray(streamsData)) {
          this.serverCameras = this.serverCameras.map(camera => {
            const streamStatus = streamsData.find(stream => stream.camera_id === camera.id)
            return Object.assign({}, camera, {
              stream_alias: (streamStatus && streamStatus.alias) || camera.alias,
              is_online: (streamStatus && streamStatus.is_online) || false
            })
          })
        }

        if (this.serverCameras.length > 0) {
          this.selectedServerCamera = this.serverCameras[0]
        }
      } catch (error) {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Error al conectar con servidor de cámaras')
      }
    },
    async connectWebRTC (streamAlias) {
      if (this.webrtcNegotiating) return
      if (!streamAlias) {
        console.error('No stream alias provided')
        return
      }

      this.webrtcNegotiating = true

      try {
        // Create RTCPeerConnection
        const config = {
          iceServers: [
            { urls: ['stun:stun.l.google.com:19302'] }
          ]
        }
        this.peerConnection = new RTCPeerConnection(config)
        // Handle ICE candidates
        this.peerConnection.onicecandidate = (event) => {
          if (event.candidate) {
            console.log('ICE candidate generated:', event.candidate)
          }
        }

        // Handle connection state changes
        this.peerConnection.onconnectionstatechange = () => {
          console.log('Connection state changed:', this.peerConnection.connectionState)
        }

        this.peerConnection.oniceconnectionstatechange = () => {
          console.log('ICE connection state changed:', this.peerConnection.iceConnectionState)
        }

        // Handle remote stream — assign to both refs since both columns may be in DOM (v-show)
        this.peerConnection.ontrack = (event) => {
          const stream = event.streams[0]
          const v1 = this.$refs.videoPlates1
          const v2 = this.$refs.videoPlates2
          ;[v1, v2].forEach(el => {
            if (el) {
              el.srcObject = stream
              el.play().catch(err => console.error('Play error:', err))
            }
          })
        }

        // Add transceiver to receive video
        this.peerConnection.addTransceiver('video', { recv: true })

        // Create offer
        const offer = await this.peerConnection.createOffer()
        await this.peerConnection.setLocalDescription(offer)

        // Step 3: WebRTC Handshake - Send SDP offer, receive SDP answer
        const webrtcUrl = `http://${this.serverIP}/api/webrtc/${streamAlias}`

        const response = await fetch(webrtcUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/sdp' },
          body: this.peerConnection.localDescription.sdp
        })

        if (!response.ok) {
          throw new Error(`Server responded with ${response.status}: ${response.statusText}`)
        }

        const sdp = await response.text()

        const answer = new RTCSessionDescription({
          type: 'answer',
          sdp: sdp
        })
        await this.peerConnection.setRemoteDescription(answer)

        this.webrtcNegotiating = false
      } catch (error) {
        console.error('Error connecting WebRTC:', error)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Error al conectar con cámara del servidor: ' + error.message)
        this.closeServerCamera()
      }
    },
    closeServerCamera () {
      // Stop all video elements
      ;[this.$refs.videoPlates1, this.$refs.videoPlates2].forEach(el => {
        if (el) {
          el.srcObject = null
          el.pause()
        }
      })

      if (this.peerConnection) {
        this.peerConnection.close()
        this.peerConnection = null
      }
      this.webrtcNegotiating = false
      this.isVideoPlaying = false
      this.videoLoadRetries = 0
    },
    onVideoLoaded () {
      this.isVideoPlaying = true
      this.videoLoadRetries = 0
    },
    onVideoPlay () {
      this.isVideoPlaying = true
    },
    onVideoError (error) {
      this.isVideoPlaying = false
      this.videoLoadRetries++
      console.error('Video error:', error, 'Retry count:', this.videoLoadRetries)
      if (this.videoLoadRetries < this.maxVideoLoadRetries) {
        setTimeout(() => {
          if (this.videoElementPlates && this.videoElementPlates.srcObject) {
            this.videoElementPlates.play().catch(err => console.error('Retry play error:', err))
          }
        }, 1000)
      } else {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'No se pudo cargar el video después de varios intentos')
      }
    },
    async switchCameraMode (mode) {
      this.cameraMode = mode

      if (mode === 'server') {
        [this.$refs.webcam1, this.$refs.webcam2].forEach(webcam => {
          if (webcam) {
            webcam.stop()
          }
        })
        this.closeServerCamera()
        await this.loadServerCameras()
        if (this.selectedServerCamera) {
          this.$nextTick(() => {
            this.connectWebRTC(this.selectedServerCamera.stream_alias || this.selectedServerCamera.alias)
          })
        }
      } else {
        this.closeServerCamera()
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 300))
        this.$nextTick(() => {
          [this.$refs.webcam1, this.$refs.webcam2].forEach(webcam => {
            if (webcam) {
              webcam.start()
            }
          })
        })
      }
    },
    async onServerCameraChange () {
      if (this.cameraMode === 'server' && this.selectedServerCamera) {
        this.closeServerCamera()
        await this.$nextTick()
        this.connectWebRTC(this.selectedServerCamera.stream_alias || this.selectedServerCamera.alias)
      }
    },
    getHouses () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/resident_house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.houses = []
          } else {
            this.houses = response.data
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getServices: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/service/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.services = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    textServices: item => (item.name === null ? 'n/a' : item.name),
    example2: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')' + ' (' + (item.phone2 === null ? 'n/a' : item.phone2) + ')' + ' (' + (item.phone3 === null ? 'n/a' : item.phone3) + ')',
    example3: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')' + ' (' + (item.phone2 === null ? 'n/a' : item.phone2) + ')' + ' (' + (item.phone3 === null ? 'n/a' : item.phone3) + ')' + ' (' + (item.fullname === '' ? 'n/a' : item.fullname) + ')',
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number),
    customFilterNumberResident (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.street.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() + ' ' + item.number.toLowerCase() + item.fullname.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      }
      const searchText = queryText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilterNumber (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.street.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() + ' ' + item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilterService (item, queryText) {
      var text = ''
      if (item.name === null) {
        text = 'n/a'
      } else {
        text = item.name.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilter (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    cleanFields () {
      this.residents = []
      this.resident_name = ''
      this.errors = []
      this.notes = ''
      this.idHouse = {
        id: ''
      }
      this.idHouse2 = []
      this.idService = ''
      this.first_name = ''
      this.imageCaptured2 = ''
      this.imageCapturedINEBack = ''
      this.imageCaptured3 = ''
      this.bandMsgVacationMode = false
      this.bandInstructions = false
      this.msgInstructions = ''
      this.bandAdditionalPersonCode = false
      this.bandParcel = false
      this.additionalPersons = []
      this.idGuestByEvent = null
      this.idGuestByDelivery = null
    },
    cleanAdditionalPersonFields () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$store.commit('setPhotosAdditionalPerson', [])
      localStorage.removeItem('listStorePhotosCameraAdditionalPerson')
    },
    clear () {
      this.cleanFields()
      this.errors = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    rotateBase64Image90deg (base64Image, isClockwise, index, twoSideINE) {
      // create an off-screen canvas
      var offScreenCanvas = document.createElement('canvas')
      var offScreenCanvasCtx = offScreenCanvas.getContext('2d')

      // cteate Image
      var img = new Image()
      img.src = base64Image

      // set its dimension to rotated size
      offScreenCanvas.height = img.width
      offScreenCanvas.width = img.height

      // rotate and draw source image into the off-screen canvas:
      if (isClockwise) {
        // offScreenCanvasCtx.translate(img.width, img.height)
        offScreenCanvasCtx.rotate(90 * Math.PI / 180)
        offScreenCanvasCtx.translate(0, -offScreenCanvas.width)
      } else {
        // offScreenCanvasCtx.translate(img.width, img.height)
        offScreenCanvasCtx.rotate(-90 * Math.PI / 180)
        offScreenCanvasCtx.translate(-offScreenCanvas.height, 0)
      }
      offScreenCanvasCtx.drawImage(img, 0, 0)

      // encode image to data-uri with base64
      this.rotateimage = offScreenCanvas.toDataURL('image/jpeg', 100)
      var rotateimage2 = this.rotateimage.replace('data:image/jpeg;base64,', '')
      this.updateItemPhoto(index, rotateimage2, twoSideINE)
      // this.photosCamera[index] = rotateimage2
      // console.log(rotateimage2)
      // this.imageCaptured = this.rotateimage
    },
    rotateBase64Image180deg (base64Image, isClockwise, index, twoSideINE) {
      // create an off-screen canvas
      var offScreenCanvas = document.createElement('canvas')
      var offScreenCanvasCtx = offScreenCanvas.getContext('2d')

      // cteate Image
      var img = new Image()
      img.src = base64Image

      // set its dimension to rotated size
      offScreenCanvas.height = img.height
      offScreenCanvas.width = img.width

      // rotate and draw source image into the off-screen canvas:
      if (isClockwise) {
        offScreenCanvasCtx.translate(img.width, img.height)
        offScreenCanvasCtx.rotate(180 * Math.PI / 180)
      } else {
        offScreenCanvasCtx.translate(img.width, img.height)
        offScreenCanvasCtx.rotate(-180 * Math.PI / 180)
      }
      offScreenCanvasCtx.drawImage(img, 0, 0)

      // encode image to data-uri with base64
      this.rotateimage = offScreenCanvas.toDataURL('image/jpeg', 100)
      var rotateimage2 = this.rotateimage.replace('data:image/jpeg;base64,', '')
      this.updateItemPhoto(index, rotateimage2, twoSideINE)
      // this.photosCamera[index] = rotateimage2
      // console.log(rotateimage2)
      // this.imageCaptured = this.rotateimage
    },
    rotateBase64Image90degAdditionalPerson (base64Image, isClockwise, index) {
      console.log('Rotate Additional Person')
      // create an off-screen canvas
      var offScreenCanvas = document.createElement('canvas')
      var offScreenCanvasCtx = offScreenCanvas.getContext('2d')

      // cteate Image
      var img = new Image()
      img.src = base64Image

      // set its dimension to rotated size
      offScreenCanvas.height = img.width
      offScreenCanvas.width = img.height

      // rotate and draw source image into the off-screen canvas:
      if (isClockwise) {
        offScreenCanvasCtx.rotate(90 * Math.PI / 180)
        offScreenCanvasCtx.translate(0, -offScreenCanvas.width)
      } else {
        offScreenCanvasCtx.rotate(-90 * Math.PI / 180)
        offScreenCanvasCtx.translate(-offScreenCanvas.height, 0)
      }
      offScreenCanvasCtx.drawImage(img, 0, 0)

      // encode image to data-uri with base64
      this.rotateimage = offScreenCanvas.toDataURL('image/jpeg', 100)
      var rotateimage2 = this.rotateimage.replace('data:image/jpeg;base64,', '')
      this.updateItemPhotoAdditionalPerson(index, rotateimage2)
      // this.editedItem.photo = this.rotateimage
      // this.photosCameraAdditionalPerson[index] = rotateimage2
      // console.log(rotateimage2)
      // this.imageCaptured = this.rotateimage
    },
    rotateBase64Image180degAdditionalPerson (base64Image, isClockwise, index) {
      console.log('Rotate Additional Person')
      // create an off-screen canvas
      var offScreenCanvas = document.createElement('canvas')
      var offScreenCanvasCtx = offScreenCanvas.getContext('2d')

      // cteate Image
      var img = new Image()
      img.src = base64Image

      // set its dimension to rotated size
      offScreenCanvas.height = img.height
      offScreenCanvas.width = img.width

      // rotate and draw source image into the off-screen canvas:
      if (isClockwise) {
        offScreenCanvasCtx.translate(img.width, img.height)
        offScreenCanvasCtx.rotate(180 * Math.PI / 180)
      } else {
        offScreenCanvasCtx.translate(img.width, img.height)
        offScreenCanvasCtx.rotate(-180 * Math.PI / 180)
      }
      offScreenCanvasCtx.drawImage(img, 0, 0)

      // encode image to data-uri with base64
      this.rotateimage = offScreenCanvas.toDataURL('image/jpeg', 100)
      var rotateimage2 = this.rotateimage.replace('data:image/jpeg;base64,', '')
      this.updateItemPhotoAdditionalPerson(index, rotateimage2)
      // this.editedItem.photo = this.rotateimage
      // this.photosCameraAdditionalPerson[index] = rotateimage2
      // console.log(rotateimage2)
      // this.imageCaptured = this.rotateimage
    },
    createRecordsAdditionalPeopleNoCode (id) {
      console.log('TAM ====> ', this.additionalPersons.length)
      var bodyFormData = new FormData()
      var fileImageFront = null

      for (let i = 0; i < this.additionalPersons.length; i++) {
        const newID = this.$uuid.v4()
        bodyFormData.append('idAccess', id)
        bodyFormData.append('full_name', this.additionalPersons[i].full_name)
        fileImageFront = this.dataURLtoFile('data:image/jpeg;base64,' + this.additionalPersons[i].data, 'photo' + newID + '.jpeg')
        bodyFormData.append('photo', fileImageFront)
      }
      console.log(bodyFormData)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/additional_people_no_code_create/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('access_success'))
          this.deleteItemPhoto(this.indexTag)
          this.deleteItemPhotoINEBack(this.indexTag)
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    createAccessWithoutCode () {
      this.loading = true
      this.errors = []
      console.log('Access Without Code Created ....')
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()

      bodyFormData.set('housing_unit', this.getProfile.idHousingUnit)
      bodyFormData.set('house', this.idHouse.id)
      if (this.idService !== undefined && this.idService.length > 0 && (this.first_name !== '')) {
        bodyFormData.set('name_guest', this.first_name + ' ' + '(' + this.idService.toUpperCase() + ')')
      } else {
        bodyFormData.set('name_guest', this.first_name)
      }
      let auxNotes = this.notes
      console.log('Valor de resident_name ', this.resident_name)
      if (this.notes !== '' && this.resident_name !== null && this.resident_name !== undefined && this.resident_name !== '') {
        auxNotes = this.notes + ' Autorizó ' + this.resident_name.fullname
      }
      bodyFormData.set('comments', auxNotes)
      if (this.additionalPersons.length > 0) {
        bodyFormData.set('additionalPerson', 'true')
      }
      bodyFormData.set('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))

      if (this.imageCaptured3 !== '' && this.imageCaptured3.length > 6) {
        fileImageFront = this.dataURLtoFile(this.imageCaptured3, 'photo' + newID + '.jpeg')
      }
      bodyFormData.append('photo', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/access_no_code_create_get/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          console.log('ID del nuevo registro = ', ok.data.id)
          if (this.additionalPersons.length > 0) {
          //   Llamar a funcion que genere registros de personas adicionales
            this.createRecordsAdditionalPeopleNoCode(ok.data.id)
          } else {
            this.loading = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('access_success'))
            this.deleteItemPhoto(this.indexTag)
            this.deleteItemPhotoINEBack(this.indexTag)
            setTimeout(this.clear, 3000)
          }
          if (this.idGuestByEvent !== null) {
            console.log('Se actualiza Registro de Acceso de la invitado al Evento.')
            this.changeStatusGuestByEvent(ok.data.id)
          }
          if (this.idGuestByDelivery !== null) {
            console.log('Se actualiza Registro de Acceso al Delivery.')
            this.changeStatusGuestByDelivery(ok.data.id)
          }
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    changeStatusGuestByEvent (uuid) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/event/guest/status/' + this.idGuestByEvent + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          status: 1,
          idAccessNoCode: uuid
        }
      }
      axios(config)
        .then(ok => {
          console.log('Status del invitado al Evento actualizado Correctamente.', ok)
        })
        .catch(error => {
          console.log('Error al cambiar status del invitado al Evento.', error)
        })
    },
    changeStatusGuestByDelivery (uuid) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/delivery/' + this.idGuestByDelivery,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          status: 1,
          idAccessNoCode: uuid
        }
      }
      axios(config)
        .then(ok => {
          console.log('Status del invitado al Evento actualizado Correctamente.', ok)
        })
        .catch(error => {
          console.log('Error al cambiar status del invitado al Evento.', error)
        })
    },
    addEvent () {
      let { color, icon } = this.genAlert()
      const previousColor = this.items[0].color

      while (previousColor === color) {
        color = this.genColor()
      }
      this.items.push({
        id: this.nonce++,
        color,
        icon
      })
      if (this.nonce > 6) {
        this.items.pop()
      }
    },
    genAlert () {
      const color = this.genColor()

      return {
        color,
        icon: this.genIcon(color)
      }
    },
    genColor () {
      return COLORS[Math.floor(Math.random() * 3)]
    },
    genIcon (color) {
      return ICONS[color]
    },
    start () {
      this.interval = setInterval(this.addEvent, 3000)
    },
    stop () {
      clearInterval(this.interval)
      this.interval = null
    },
    create_acceso (index, aQr) {
      console.log(aQr)
      console.log('IMAGEN 2')
      console.log(this.imageCaptured2)
      var bodyFormData = new FormData()
      var fileImage = null
      const newID = this.$uuid.v4()

      bodyFormData.set('qr_code', aQr)
      bodyFormData.set('comments', this.comments)
      bodyFormData.set('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))
      if (this.imageCaptured2 !== '' && this.imageCaptured2.length > 6) {
        fileImage = this.dataURLtoFile(this.imageCaptured2, 'plates' + newID + '.jpeg')
      }
      bodyFormData.append('vehicle_plates', fileImage)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/Access/Create/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(response => {
          console.log(response)
          this.errores_guard = this.$t('mensaje_alta_acceso_in')
          this.head_color = 'green display-1 text--primary'
          this.dialog_errores = true
          this.comments = ''
          this.deleteItem(index)
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          console.log(error.response.data)
          this.head_color = 'red display-1 text--primary'
          this.errores_guard = error.response.data.error
          this.dialog_errores = true
        })
    },
    create_worker_access (index, aQr, status) {
      console.log(aQr)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/WorkerAccess/Create/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          qr_code: aQr,
          comments: this.comments,
          guard_house: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          console.log(response)
          if (status === 10) {
            this.comments = ''
            this.errores_guard = this.$t('mensaje_alta_acceso_in')
          } else {
            this.errores_guard = this.$t('mensaje_alta_acceso_out')
          }
          this.head_color = 'green display-1 text--primary'
          this.dialog_errores = true
          this.deleteItem(index)
        })
        .catch(error => {
          console.log(error.response.data)
          this.head_color = 'red display-1 text--primary'
          this.errores_guard = error.response.data.error
          this.dialog_errores = true
        })
    },
    update_acceso (index, pk) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/Access/Update/' + pk,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_guardhouse_checkout: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          console.log(response)
          this.head_color = 'green display-1 text--primary'
          this.errores_guard = this.$t('mensaje_alta_acceso_out')
          this.dialog_errores = true
          this.deleteItem(index)
        })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    get_current_date () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = mm + '/' + dd + '/' + yyyy
      return today
    },
    deleteRecord () {
      this.loading = true
      if (localStorage.getItem('qr_devices') !== null) {
        let band = false
        let devicesAux = JSON.parse(localStorage.getItem('qr_devices'))
        console.log('Auxiluar = ', devicesAux)
        for (let i = 0; !band && i < devicesAux.length; i++) {
          if (devicesAux[i].label === this.labelDevice) {
            console.log(devicesAux[i].label, '===', this.labelDevice)
            devicesAux[i] = Object.assign(devicesAux[i], { 'data': null })
            localStorage.setItem('qr_devices', JSON.stringify(devicesAux))
            this.$store.commit('setQRDevices', JSON.parse(localStorage.getItem('qr_devices')))
            band = true
          }
        }
        console.log(JSON.parse(localStorage.getItem('qr_devices')))
      }
      this.loading = false
    },
    deleteItem (index) {
      console.log(index)
      var aux = []
      aux = JSON.parse(localStorage.getItem('listStoreQrCodes')) || []
      console.log(aux)
      if (index >= 0) aux.splice(index, 1)
      console.log(aux)
      localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
      this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
    },
    updateItemCorrectionRequest (index) {
      console.log(index)
      var aux = []
      aux = JSON.parse(localStorage.getItem('listStoreQrCodes')) || []
      console.log(aux)
      if (index >= 0) {
        aux[index].info.invitation.correction_request = true
      }
      console.log(aux)
      localStorage.setItem('listStoreQrCodes', JSON.stringify(aux))
      this.$store.commit('setQrs', JSON.parse(localStorage.getItem('listStoreQrCodes')))
    },
    deleteItemPhoto (index) {
      console.log(index)
      var aux = []
      aux = JSON.parse(localStorage.getItem('listStorePhotosCamera')) || []
      console.log(aux)
      if (index >= 0) aux.splice(index, 1)
      console.log(aux)
      localStorage.setItem('listStorePhotosCamera', JSON.stringify(aux))
      this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
    },
    deleteItemPhotoINEBack (index) {
      console.log(index)
      var aux = []
      aux = JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack')) || []
      console.log(aux)
      if (index >= 0) aux.splice(index, 1)
      console.log(aux)
      localStorage.setItem('listStorePhotosCameraINEBack', JSON.stringify(aux))
      this.$store.commit('setPhotosINEBack', JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack')))
    },
    updateItemPhoto (index, newData, twoSideINE) {
      console.log(index)
      var aux = []
      if (twoSideINE === true) {
        aux = JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack')) || []
      } else {
        aux = JSON.parse(localStorage.getItem('listStorePhotosCamera')) || []
      }
      console.log(aux)
      if (aux.length >= 0) {
        aux[index].data = newData
        console.log(aux[index])
      }
      if (twoSideINE === true) {
        localStorage.setItem('listStorePhotosCameraINEBack', JSON.stringify(aux))
        this.$store.commit('setPhotosINEBack', JSON.parse(localStorage.getItem('listStorePhotosCameraINEBack')))
      } else {
        localStorage.setItem('listStorePhotosCamera', JSON.stringify(aux))
        this.$store.commit('setPhotos', JSON.parse(localStorage.getItem('listStorePhotosCamera')))
      }
    },
    updateItemPhotoAdditionalPerson (index, newData) {
      console.log(index)
      var aux = []
      aux = JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson')) || []
      console.log(aux)
      if (aux.length >= 0) {
        aux[index].data = newData
        console.log(aux[index])
      }
      localStorage.setItem('listStorePhotosCameraAdditionalPerson', JSON.stringify(aux))
      this.$store.commit('setPhotosAdditionalPerson', JSON.parse(localStorage.getItem('listStorePhotosCameraAdditionalPerson')))
    },
    takePicture2 () {
      console.log('Waiting for picture ...')
      this.loadingTakePicture = false
    },
    takePicture1 () {
      this.$store.commit('enableAdditionalPerson', false)
      localStorage.setItem('banderaAdditionalPerson', false)
      this.$store.commit('enableINEBack', false)
      localStorage.setItem('banderaINEBack', false)
      this.loadingTakePicture = true
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/device_activate/' + JSON.parse(localStorage.getItem('cam_devices'))[0].uuid + '/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {}
      }
      axios(config)
        .then(response => {
          console.log(response)
          setTimeout(this.takePicture2, 3000)
        })
        .catch(error => {
          console.log(error.response.data)
          this.loadingTakePicture = false
        })
    },
    takePicture2AdditionalPerson () {
      console.log('Waiting for picture Additional Person ...')
      this.loadingTakePicture = false
    },
    takePicture1AdditionalPerson () {
      this.$store.commit('enableAdditionalPerson', true)
      localStorage.setItem('banderaAdditionalPerson', true)
      this.$store.commit('enableINEBack', false)
      localStorage.setItem('banderaINEBack', false)
      this.loadingTakePicture = true
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/device_activate/' + JSON.parse(localStorage.getItem('cam_devices'))[0].uuid + '/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {}
      }
      axios(config)
        .then(response => {
          console.log(response)
          setTimeout(this.takePicture2AdditionalPerson, 3000)
        })
        .catch(error => {
          console.log(error.response.data)
          this.loadingTakePicture = false
        })
    },
    takePicture2INEBack () {
      console.log('Waiting for picture INE Back ...')
      this.loadingTakePicture = false
    },
    takePicture1INEBack () {
      this.$store.commit('enableINEBack', true)
      localStorage.setItem('banderaINEBack', true)
      this.$store.commit('enableAdditionalPerson', false)
      localStorage.setItem('banderaAdditionalPerson', false)
      this.loadingTakePicture = true
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/device_activate/' + JSON.parse(localStorage.getItem('cam_devices'))[0].uuid + '/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {}
      }
      axios(config)
        .then(response => {
          console.log(response)
          setTimeout(this.takePicture2INEBack, 3000)
        })
        .catch(error => {
          console.log(error.response.data)
          this.loadingTakePicture = false
        })
    }
  }
}
</script>

<style scoped>
    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #439f46;
        color: white;
    }
    .edge {
        border-radius: 8px;
        border-color: #439f46 #439f46 #439f46 #439f46;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    th {
        text-align: left;
    }
    table, th, td {
      border:1px solid black;
    }

    th, td {
      text-align: center;
      padding: 8px;
    }

    tr:nth-child(even) {
      background-color: #D6EEEE;
    }

    /* Camera Feed Styles */
    .camera-feed-container {
      width: 100%;
      height: 164px;
      background-color: #000;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .camera-box {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
      background-color: #000;
      display: block;
    }

    /* Reemplaza v-avatar — cámara pequeña en esquina superior izquierda */
    .camera-preview-box {
      width: 164px;
      height: 164px;
      background-color: grey;
      overflow: hidden;
      display: block;
    }

    /* Fuerza al <video> interno de vue-web-cam a llenar el contenedor */
    .camera-preview-box /deep/ video {
      width: 164px;
      height: 164px;
      object-fit: cover;
      display: block;
    }
</style>
